import React from 'react'
import IFormDesignerLayout from './IFormDesignerLayout';
import { createUniqueId, getColumnLayout, getFormId, getStepIndex, getSubStepIndex } from './IFormDesignerLogic';
import axios from '../../axios'
import cloneDeep from 'lodash-es/cloneDeep';
import {ThemeJSON} from './Theme/ThemeJSON';

export function updateFormStateStructure(formStateJson, sectionId, newSectionJson) {
    var newJSON = {};
    var newJSONChildren = [];
    var colComps = [];
    if (formStateJson.id === sectionId) {
        return newSectionJson;
    } 
    else if(formStateJson?.elem_type==="advancelistView" && formStateJson?.listviewFrameLayoutJson){
        let testJson= formStateJson;
        const testJson_listviewFrameLayoutJson = updateFormStateStructure(testJson?.listviewFrameLayoutJson, sectionId, newSectionJson);
        testJson.listviewFrameLayoutJson = testJson_listviewFrameLayoutJson;
        return testJson;
    }
    else {
        var children = formStateJson.children;
        if (children !== null && children !== undefined) {
            if (children.length > 0) {
                formStateJson.children = children.map(
                    child => {
                        return updateFormStateStructure(child, sectionId, newSectionJson);
                    }
                )
            }
        }
        return formStateJson;
    }
}

export function changeLayoutMain2(next_json, columnLayout) {

    var rows = next_json.children;
    if (rows && rows.length > 0) {
        const tabChildArr = rows[0].children;
        rows[0].children = tabChildArr.map(sheetJson => {
            return changeLayout(sheetJson, columnLayout);
        })
        return next_json
    }
    else if (next_json.children.elem_type === "frame") {
        next_json.children.map(child => {
            return changeLayout(child.children, columnLayout);
        })
    }
}


export function updateFormStateStructureByElemType(formStateJson, columnLayout, view, prevView) {

    var newJSON = {};
    var newJSONChildren = [];
    var colComps = [];
    if (formStateJson.elem_type === "frame" || formStateJson.elem_type === "section" || formStateJson.elem_type === "sheet" || formStateJson.elem_type === "tab") {
        if ((formStateJson.elem_type === 'frame' && formStateJson.isParentOfTab && formStateJson.isParentOfTab === true) || formStateJson.elem_type === "sheet" || formStateJson.elem_type === "tab") {
            var tempJson = formStateJson;
            var tempJsonChildren = [];
            if (formStateJson.children) {
                tempJsonChildren.push(
                    formStateJson.children.map((element) => {
                        if (element.elem_type === "tab") {
                            var newJson = element;
                            var children = [];
                            children.push(
                                element.children.map((sheet) => {
                                    var newSheet = sheet;
                                    //changeLayoutMain2(element.children,columnLayout);
                                    newSheet.ColumnLayout = columnLayout;
                                    var newChild = [];
                                    sheet.children.map((child) => {
                                        if (child.elem_type === 'frame') {
                                            var newFrame = changeLayoutMain(child, columnLayout, view, prevView);
                                            newChild.push(newFrame);
                                        } else {
                                            var rowTemp = child;

                                            if (child.children) {
                                                var rowChildTemp = [];

                                                child.children.map((c) => {
                                                    if (c.elem_type && c.elem_type === 'column') {
                                                        // if (prevView === "web") {
                                                        //     c.w = c.md;
                                                        // } if (prevView === "tablet") {
                                                        //     c.sm = c.md;
                                                        // } if (prevView === "mobile") {
                                                        //     c.xs = c.md;
                                                        // } 
                                                        if (view === "web") {
                                                            c.md = c.w;
                                                        } if (view === "tablet") {
                                                            c.md = c.sm;
                                                        } if (view === "mobile") {
                                                            c.md = c.xs;
                                                        }
                                                        if (c.children.length > 0) {
                                                        var newchildren= c.children.map(
                                                            child => {
                                                                if(child.elem_type==="listview" && child?.listviewFrameLayoutJson){
                                                                    const testJson_listviewFrameLayoutJson = updateFormStateStructureByElemType(child?.listviewFrameLayoutJson, columnLayout, view, prevView);
                                                                    var testJson = child;
                                                                    testJson.listviewFrameLayoutJson = testJson_listviewFrameLayoutJson;
                                                                    return testJson
                                                                }
                                                                else if(child.elem_type==="advancelistView" && child?.listviewFrameLayoutJson){
                                                                    const testJson_listviewFrameLayoutJson = updateFormStateStructureByElemType(child?.listviewFrameLayoutJson, columnLayout, view, prevView);
                                                                    var testJson = child;
                                                                    testJson.listviewFrameLayoutJson = testJson_listviewFrameLayoutJson;
                                                                    return testJson
                                                                }
                                                                else if(child.elem_type==="advancelistView" && child?.listviewFrameLayoutJson){
                                                                    const testJson_listviewFrameLayoutJson = updateFormStateStructureByElemType(child?.listviewFrameLayoutJson, columnLayout, view, prevView);
                                                                    var testJson = child;
                                                                    testJson.listviewFrameLayoutJson = testJson_listviewFrameLayoutJson;
                                                                    return testJson
                                                                }
                                                                else{
                                                                    const testJson = updateFormStateStructureByElemType(child, columnLayout, view, prevView);
                                                                    return testJson
                                                                }
                                                            }
                                                        )
                                                        c.children = newchildren;
                                                        }
                                                    }
                                                    rowChildTemp.push(c);
                                                    return c;
                                                });
                                                rowTemp.children = rowChildTemp;
                                            }
                                            newChild.push(rowTemp);
                                        }
                                    });
                                    newSheet.children = newChild
                                    return newSheet;
                                })
                            )
                            newJson.children = children[0];
                            return newJson;
                        } else {
                            var newJson = changeLayoutMain(element, columnLayout, view, prevView);
                            return newJson;
                        }
                    })
                );
                tempJson.children = tempJsonChildren[0];
            }
            return tempJson;
        } else {
            var newJson = changeLayoutMain(formStateJson, columnLayout, view, prevView);
            return newJson;
        }
    } else {
        var children = formStateJson.children;
        if (children !== null && children !== undefined) {
            if (children.length > 0) {
                formStateJson.children = children.map(
                    child => {
                        const testJson = updateFormStateStructureByElemType(child, columnLayout, view, prevView);
                        return testJson
                    }
                )
            }
        }
        return formStateJson;
    }
}


export function changeLayout(next_json, columnLayout, view, prevView) {
    // next_json.ColumnLayout = columnLayout;
    var colsSoFar = [];
    var rowsSoFar = [];
    var newJsonChildren = [];

    var rows = next_json.children;

    if (rows !== undefined && rows !== null) {

        for (var i = 0; i < rows.length; i++) {
            var rowObj = rows[i];
            rowObj.parent_id = next_json.id;
            if (rowObj.elem_type === 'row') {
                var columns = rowObj.children;
                if (columns.length > 0)
                    for (var col = 0; col < columns.length; col++) {
                        // if (prevView === "web") {
                        //     columns[col].w = columns[col].md;
                        // }
                        // if (prevView === "tablet") {
                        //     columns[col].sm = columns[col].md;
                        // }
                        // if (prevView === "mobile") {
                        //     columns[col].xs = columns[col].md;
                        // }
                        if (view === "web") {
                            columns[col].md = columns[col].w;
                        }
                        if (view === "tablet") {
                            columns[col].md = columns[col].sm;
                        }
                        if (view === "mobile") {
                            columns[col].md = columns[col].xs;
                        }



                        if (columns[col].children.length > 0) {                
                            var newchildren= columns[col].children.map(
                                child => {
                                    if(child?.elem_type==="listview" && child?.listviewFrameLayoutJson){
                                        const testJson_listviewFrameLayoutJson = updateFormStateStructureByElemType(child.listviewFrameLayoutJson, columnLayout, view, prevView);
                                        var testJson = child;
                                        testJson.listviewFrameLayoutJson = testJson_listviewFrameLayoutJson;
                                        return testJson
                                    }
                                    else if(child?.elem_type==="advancelistView" && child?.listviewFrameLayoutJson ){
                                        const testJson_listviewFrameLayoutJson = updateFormStateStructureByElemType(child?.listviewFrameLayoutJson, columnLayout, view, prevView);
                                        var testJson = child;
                                        testJson.listviewFrameLayoutJson = testJson_listviewFrameLayoutJson;
                                        return testJson
                                    }
                                    else if(child?.elem_type==="button" && child?.subform ){
                                        const testJson_subform = updateFormStateStructureByElemType(child.subform, columnLayout, view, prevView);
                                        var testJson = child;
                                        testJson.subform = testJson_subform;
                                        return testJson
                                    } 
                                    else if(child?.elem_type === "frame"){
                                        console.log("frame found", child)
                                        const testJson = changeLayout(child, columnLayout, view, prevView);
                                        return testJson
                                    }
                                    else{
                                        // const testJson = updateFormStateStructureByElemType(child, columnLayout, view, prevView);
                                        // return testJson
                                        return child;
                                    }
                                    
                                    // else{
                                    //     const testJson = updateFormStateStructureByElemType(child, columnLayout, view, prevView);
                                    //     return testJson
                                    // }
                                }
                            )
                            columns[col].children = newchildren; 
                            }


                        // if(columns[col]?.elem_type==="listview"){
                        //     const testJson_listviewFrameLayoutJson = updateFormStateStructureByElemType(columns[col]?.listviewFrameLayoutJson, columnLayout, view, prevView);
                        //     // var testJson = columns[col];
                        //     columns[col].listviewFrameLayoutJson = testJson_listviewFrameLayoutJson;
                        //     // return testJson
                        // }
                    }

            } else {
            }
        }
        return next_json;
    } else {
        return next_json;
    }
}

function computeLayout(dividend, dividor){
    var quotient=Math.floor(dividend/dividor);
    if(quotient===0){
        quotient=1;
    }
    if(dividend===3 && dividor===2){
        quotient=2;
    }
    if(dividend===3 && dividor===4){
        quotient=1;
    }
    return quotient;
}

export function changeLayoutOfElements(next_json, columnLayout,type,fromListview) {
    // var prevColLayout=next_json.ColumnLayout;
    // next_json.ColumnLayout = columnLayout;

    var colsSoFar = [];
    var rowsSoFar = [];
    var newJsonChildren = [];
    var rows = next_json.children;

    if (rows !== undefined && rows !== null) {
        for (var i = 0; i < rows.length; i++) {


            // change layout of existing columns
            colsSoFar = [];
            var rowObj = rows[i];
            rowObj.parent_id = next_json.id;

            if (rowObj.elem_type === 'row') {

                var columns = rowObj.children;
                for (var col = 0; col < columns.length; col++) {
                    
                    columns[col].md = 12/columnLayout;
                    const deviceFromDom=document.querySelector("#canvasId")?.getAttribute("deviceMode");

                    if(deviceFromDom==="web"){
                        columns[col].w = 12/columnLayout;
                        // columns[col].sm = 12/computeLayout( parseInt(columnLayout), 2);
                        // columns[col].xs = 12/computeLayout( parseInt(columnLayout), 4);
                    }
                    else if(deviceFromDom==="tablet"){
                        columns[col].sm = 12/columnLayout;
                    }
                    else if(deviceFromDom==="mobile"){
                        columns[col].xs = 12/columnLayout;
                    }
                    colsSoFar.push(columns[col]);
                }

                if(columnLayout > columns.length && !fromListview){
                    const noOfNewCols= columnLayout - columns.length;
                    
                    for (var newCol = 0; newCol < noOfNewCols ; newCol++) {
                        var coljson = {};
                        coljson.elem_type = "column";
                        coljson.children = [];
                        coljson.id = createUniqueId('column');
                        coljson.isInsideListview = type === "listview" ? true : false
                        coljson.md = 12/columnLayout;
                        if(rowObj?.frameIndex)
                        coljson.frameIndex = rowObj?.frameIndex;
                        if(rowObj?.parentStepIndex)
                        coljson.parentStepIndex = rowObj?.parentStepIndex
                        const deviceFromDom=document.querySelector("#canvasId")?.getAttribute("deviceMode");

                        if(deviceFromDom==="web"){
                            coljson.w = 12/columnLayout;
                            coljson.sm = getColumnLayout("tablet");
                            coljson.xs = getColumnLayout("mobile");
                        }
                        else if(deviceFromDom==="tablet"){
                            coljson.sm = 12/columnLayout;
                            coljson.sm = getColumnLayout("web");
                            coljson.xs = getColumnLayout("mobile");
                        }
                        else if(deviceFromDom==="mobile"){
                            coljson.xs = 12/columnLayout;
                            coljson.sm = getColumnLayout("web");
                            coljson.xs = getColumnLayout("tablet");
                        }
                        colsSoFar.push(coljson);
                    }
                }
                
                // else if(columnLayout < columns.length && !fromListview){
                //     // const extraNumofCols= columns.length - columnLayout;
                //     const extraNumofCols_oflastrow= (columns.length)%columnLayout;
                //     const nowOf_row= extraNumofCols_oflastrow===0 ? Math.floor( (columns.length)/columnLayout) : Math.floor( (columns.length)/columnLayout) +1 ;
                    
                //     var are_extra_cols_empty= true;

                //     for (var row_count = nowOf_row; row_count > 0 ; row_count--) {
                //         var extraNumofCols_ofcurrentrow= row_count===nowOf_row ? extraNumofCols_oflastrow : columnLayout;

                //         function loopcheck(extracol_count){
                //             if(row_count===nowOf_row){
                //                return extracol_count < columns.length
                //             }
                //             else {
                //                 return extracol_count < (row_count)*columnLayout
                //             }
                //         }

                //         for (var extracol_count = (row_count-1)*columnLayout; loopcheck(extracol_count) ; extracol_count++) {
                //             if( colsSoFar[extracol_count].children.length!==0 ){
                //                 are_extra_cols_empty = false;
                //             }
                //         }
                //         if(are_extra_cols_empty && row_count >1 ){
                //             colsSoFar.splice( (row_count-1)*columnLayout , extraNumofCols_ofcurrentrow===0 ? columnLayout : extraNumofCols_ofcurrentrow );
                //             // for removing extra columns
                //         }
                //         else{
                //             break;
                //         }
                //     }

                //     const extraNumofCols= (colsSoFar.length)%columnLayout;
                //     are_extra_cols_empty= true;
                //     if(extraNumofCols!==0){
                //         for (var extracol_count = (colsSoFar.length-columnLayout); extracol_count < colsSoFar.length ; extracol_count++) {
                //             if( colsSoFar[extracol_count].children.length!==0 ){
                //                 are_extra_cols_empty = false;
                //             }
                //         }
                //     }
                    
                //     if(!are_extra_cols_empty && columns.length%columnLayout!==0 ){
                //         // const extraNum_ofCols= columns.length - columnLayout;
                //         // const extraNum_ofCols_toadd = Math.floor(extraNum_ofCols/columnLayout) +2;

                //         // for adding extra columns

                //         const extraNum_ofCols= (columns.length)%columnLayout;
                //         const extraNum_ofCols_toadd = columnLayout - extraNum_ofCols;
                        
                //         for (var newCol = 0; newCol < extraNum_ofCols_toadd ; newCol++) {
                //             var coljson = {};
                //             coljson.elem_type = "column";
                //             coljson.children = [];
                //             coljson.id = createUniqueId('column');
                //             coljson.isInsideListview = type === "listview" ? true : false
                //             coljson.frameIndex = rowObj?.frameIndex;
                //             if(rowObj?.parentStepIndex)
                //             coljson.parentStepIndex = rowObj?.parentStepIndex
                //             coljson.md = 12/columnLayout;
                //             const deviceFromDom=document.querySelector("#canvasId")?.getAttribute("deviceMode");
    
                //             if(deviceFromDom==="web"){
                //                 coljson.w = 12/columnLayout;
                //                 coljson.sm = getColumnLayout("tablet");
                //                 coljson.xs = getColumnLayout("mobile");
                //             }
                //             else if(deviceFromDom==="tablet"){
                //                 coljson.sm = 12/columnLayout;
                //                 coljson.sm = getColumnLayout("web");
                //                 coljson.xs = getColumnLayout("mobile");
                //             }
                //             else if(deviceFromDom==="mobile"){
                //                 coljson.xs = 12/columnLayout;
                //                 coljson.sm = getColumnLayout("tablet");
                //                 coljson.xs = getColumnLayout("web");
                //             }
                //             colsSoFar.push(coljson);
                //         }
                //     }
                
                // }


                var rowJson = {};
                rowJson.parent_id = next_json.id;
                rowJson.elem_type = "row";
                rowJson.isInsideListview = type === "listview" ? true : false
                rowJson.children = [...colsSoFar];
                if(rowObj?.frameIndex)
                rowJson.frameIndex = rowObj?.frameIndex;
                if(rowObj?.parentStepIndex)
                rowJson.parentStepIndex = rowObj?.parentStepIndex
                rowJson.id = next_json?.children?.[0]?.id;
                newJsonChildren.push(rowJson);

            }
        }
        next_json.children = [...newJsonChildren];
        return next_json;
    } 
    else {
        return next_json;
    }
}

export function changeLayoutOfElements2(next_json, columnLayout) {
    // next_json.ColumnLayout = columnLayout;
    var colsSoFar = [];
    var rowsSoFar = [];
    var newJsonChildren = [];
    var rows = next_json.children;
    if (rows !== undefined && rows !== null) {
        for (var i = 0; i < rows.length; i++) {
            colsSoFar = [];
            var rowObj = rows[i];
            rowObj.parent_id = next_json.id;

            if (rowObj.elem_type === 'row') {
                var columns = rowObj.children;
                for (var col = 0; col < columns.length; col++) {
                    
                    columns[col].md = 12/columnLayout;
                    const deviceFromDom=document.querySelector("#canvasId")?.getAttribute("deviceMode");

                    if(deviceFromDom==="web"){
                        columns[col].w = 12/columnLayout;
                        columns[col].sm = 12/computeLayout( parseInt(columnLayout), 2);
                        columns[col].xs = 12/computeLayout( parseInt(columnLayout), 4);
                    }
                    else if(deviceFromDom==="tablet"){
                        columns[col].sm = 12/columnLayout;
                    }
                    else if(deviceFromDom==="mobile"){
                        columns[col].xs = 12/columnLayout;
                    }
                    colsSoFar.push(columns[col]);
                }
                if (colsSoFar.length > 0) {
                    var colAddedCount = 0;
                    var colWidth = 12 / columnLayout;
                    var rowsAdded = Math.floor(colsSoFar.length / columnLayout);
                    if ((colsSoFar.length % columnLayout) > 0) {
                        rowsAdded++;
                    }
                    for (var r = 0; r < rowsAdded; r++) {
                        var rowJson = {};
                        rowJson.parent_id = next_json.id;
                        if (rowsSoFar.length < r) {
                            if (rowsSoFar[r] !== null && rowsSoFar[r] !== undefined) {
                                rowJson.id = rowsSoFar[r];
                            } else {
                                rowJson.id = createUniqueId('row');
                            }
                        } else {
                            rowJson.id = createUniqueId('row');
                        }
                        rowJson.elem_type = "row";
                        rowJson.children = [];
                        for (var c = 0; c < columnLayout; c++) {
                            if (colAddedCount < colsSoFar.length) {
                                rowJson.frameIndex = colsSoFar[colAddedCount].frameIndex;
                                colsSoFar[colAddedCount].md = colWidth;
                                colsSoFar[colAddedCount].w = 4;
                                colsSoFar[colAddedCount].sm = 6;
                                colsSoFar[colAddedCount].xs = 12;
        
                                const deviceFromDom=document.querySelector("#canvasId")?.getAttribute("deviceMode");
        
                                if(deviceFromDom==="web"){
                                    colsSoFar[colAddedCount].w = colWidth;
                                    colsSoFar[colAddedCount].sm = 12/computeLayout( parseInt(columnLayout), 2);
                                    colsSoFar[colAddedCount].xs = 12/computeLayout( parseInt(columnLayout), 4);
                                }
                                else if(deviceFromDom==="tablet"){
                                    colsSoFar[colAddedCount].sm = colWidth;
                                }
                                else if(deviceFromDom==="mobile"){
                                    colsSoFar[colAddedCount].xs = colWidth;
                                }
                                rowJson.children.push(colsSoFar[colAddedCount]);
                                colAddedCount++;
                            }
                            
                            else {
                                var newColumn = {};
                                newColumn.children = [];
                                newColumn.elem_type = "column"
                                newColumn.style = ThemeJSON["column"];
                                
                                newColumn.frameIndex = rowObj.frameIndex;
                                newColumn.id = createUniqueId('column');
                                newColumn.md = colWidth;
                                newColumn.sm = 6;
                                newColumn.w = 4;
                                newColumn.xs = 12;
        
                                const deviceFromDom=document.querySelector("#canvasId")?.getAttribute("deviceMode");
        
                                if(deviceFromDom==="web"){
                                    newColumn.w = 12/columnLayout;
                                    newColumn.sm = 12/computeLayout( parseInt(columnLayout), 2);
                                    newColumn.xs = 12/computeLayout( parseInt(columnLayout), 4);
                                }
                                else if(deviceFromDom==="tablet"){
                                    newColumn.sm = colWidth;
                                }
                                else if(deviceFromDom==="mobile"){
                                    newColumn.xs = colWidth;
                                }
                                rowJson.children.push(newColumn);
                            }
                        }
                        newJsonChildren.push(rowJson);
                    }
                }
            }
            else {
                newJsonChildren.push(rowObj);
                
            }
        }
        
        next_json.children = [...newJsonChildren];
        return next_json;
    } 
    else {
        return next_json;
    }

}


export function changeLayoutMain(next_json, columnLayout, view, prevView) {
    var rows = next_json.children;
    if (rows && rows.length > 1 && rows[0].elem_type === "tab") {
        const tabChildArr = rows[0].children;
        rows[0].children = tabChildArr.map(sheetJson => {
            return changeLayout(sheetJson, columnLayout, view, prevView);
        })
        return next_json
    }
    else {
        return changeLayout(next_json, columnLayout, view, prevView);
    }
}

export function changeColumnWidth(formStatejson, columnId, columnData, widthClass, colWidth, type) {
    if (formStatejson !== undefined && formStatejson !== null) {
        if (formStatejson.id === columnId) {
            formStatejson = columnData;
            return formStatejson
        } else {
            if (formStatejson.children !== undefined && formStatejson.children !== null) {
                var children = [];
                children = formStatejson.children.map(
                    child => {
                        if (child !== null && child !== undefined) {
                            if (child.id !== null && child.id !== undefined) {
                                if (child.id === columnId) {
                                        if(type === "width"){
                                            columnData[widthClass] = colWidth;
                                            child[widthClass] = colWidth;
                                            child.w = columnData.w;
                                            child.sm = columnData.sm;
                                            child.xs = columnData.xs;
                                            // if(columnData.children.length>0){
                                            //     child.children = columnData?.children;
                                            // }
                                        }
                                        else if(type === "height"){
                                            child.style["colheight"] = colWidth
                                            if(columnData?.style?.colheight2)
                                                child.style["colheight2"] = columnData.style.colheight2;
                                        }
                                        return child;
                                }
                                else {
                                    return changeColumnWidth(child, columnId, columnData, widthClass, colWidth, type);
                                }
                            }
                        }
                    }
                );
                formStatejson.children = children;
                return formStatejson

            }
        }
    }
    return formStatejson;
}

var controlFound=false;

export function controlFoundFalseMaker(){
    controlFound = false;
}

export function updateComponentInJson(formStatejson, controlId, controlData, parentCall = true) {
    if (formStatejson !== undefined && formStatejson !== null && controlId !== undefined && controlData !== undefined) {
        if (formStatejson.id === controlId) {
            formStatejson = controlData;
        } else if (formStatejson.children !== undefined && formStatejson.children !== null) {
            formStatejson.children = formStatejson.children.map(
                child => {
                    if (child !== null && child !== undefined) {
                        if (child.id !== null && child.id !== undefined) {
                            if (child.id === controlId) {
                                if (child?.elem_type === controlData?.elem_type || child?.controlName === controlData?.controlName || child?.elem_type === controlData?.controlName) {
                                    // if (controlId === "table103") {
                                        // }
                                    return { ...controlData }; // Updated child
                                }
                            } 
                            // else if (Object.keys(child).includes("subform")) {
                            //     return {
                            //         ...child,
                            //         subform: updateComponentInJson(child.subform, controlId, controlData, parentCall = false),
                            //     }; // Recursive update for subform
                            // } 
                            else {
                                return updateComponentInJson(child, controlId, controlData, parentCall = false); // Recurse
                            }
                        }
                    }
                    return child; // No changes for unmatched child
                }
            );
        }
    }

    if (parentCall === true) {
        controlFound = false; // Ensure this is defined elsewhere if needed
    }
    return formStatejson;
}


let relocateControleValue=null;
let controleIndex = -1
let controleIndex2 = -1
let controlReference = null
let controlReference2= null

export const updateFrameIndex = (state, updatedIndex, isSheetElementIndex = false, elementIndexSwap = false, sheetElementFrameIndexSwap = false) => {
    if(!isSheetElementIndex && !sheetElementFrameIndexSwap){
        if(!elementIndexSwap)
            state.frameIndex = updatedIndex;
        else if(state?.elementIndex)
            state.elementIndex = updatedIndex
    }
    else {
        if(!sheetElementFrameIndexSwap)
            state.sheetElementIndex = updatedIndex;
        else if(state?.sheetFrameElementIndex)
            state.sheetFrameElementIndex = updatedIndex
    }
    if (state.children) {
        for(let i=0; i < state.children.length;i++){
            if(state.children[i].children) {
                updateFrameIndex(state.children[i],updatedIndex, isSheetElementIndex, elementIndexSwap, sheetElementFrameIndexSwap);
            }
            else if(state.children[i].tileContents) {
                if(!isSheetElementIndex && !sheetElementFrameIndexSwap){
                    if(!elementIndexSwap)
                        state.children[i].frameIndex = updatedIndex;
                    else if(state?.children[i]?.elementIndex)
                        state.children[i].elementIndex = updatedIndex
                }
                else{
                    if(!sheetElementFrameIndexSwap)
                        state.children[i].sheetElementIndex = updatedIndex;
                    else if(state?.children[i]?.sheetFrameElementIndex)
                        state.children[i].sheetFrameElementIndex = updatedIndex;
                } 
                    
                for(let j = 0 ; j < state.children[i].tileContents.length; j++) {
                    if(!isSheetElementIndex && !sheetElementFrameIndexSwap){
                        if(!elementIndexSwap)
                            state.children[i].tileContents[j].frameIndex = updatedIndex;
                        else if(state?.children[i]?.tileContents[j]?.elementIndex) 
                            state.children[i].tileContents[j].elementIndex = updatedIndex;
                    }
                    else {
                        if(!sheetElementFrameIndexSwap)
                            state.children[i].tileContents[j].sheetElementIndex = updatedIndex;
                        else if(state?.children[i]?.tileContents[j]?.sheetFrameElementIndex)
                            state.children[i].tileContents[j].sheetFrameElementIndex = updatedIndex
                    }
                }
            }
            else {
                if(!isSheetElementIndex && !sheetElementFrameIndexSwap){
                    if(!elementIndexSwap)
                        state.children[i].frameIndex = updatedIndex;
                    else if(state?.children[i]?.elementIndex) 
                        state.children[i].elementIndex = updatedIndex;
                }
                else{
                    if(!sheetElementFrameIndexSwap)
                        state.children[i].sheetElementIndex = updatedIndex;
                    else if(state?.children[i]?.sheetFrameElementIndex)
                        state.children[i].sheetFrameElementIndex = updatedIndex;
                }
            }
        }
    }
    else {
        return;
    }
}

export const swapFrame = (formState, prevPosition, newPosition, isSheetElementIndex = false) => {
    if(isSheetElementIndex){
        const prev = prevPosition;
        const new1 = newPosition;
        for(let i = 0; i<formState?.length; i++){
            if(formState[i]?.sheetElementIndex == (prev)){
                prevPosition = i
            }
            else if(formState[i]?.sheetElementIndex == (new1)){
                newPosition = i
            }
        }
    }
    const prevFrameIndex = isSheetElementIndex ? parseInt(formState[prevPosition].sheetElementIndex) : parseInt(formState[prevPosition].frameIndex);
    const element = formState[newPosition];
    formState.pop();
    formState.splice(prevPosition, 0, element);
    updateFrameIndex(formState[prevPosition], prevFrameIndex, isSheetElementIndex);
   
    for(let i = prevPosition + 1 ; i <= newPosition; i++) {
        updateFrameIndex(formState[i], isSheetElementIndex ? parseInt(formState[i].sheetElementIndex) + 1 : parseInt(formState[i].frameIndex) + 1, isSheetElementIndex);
    }
}

export const replaceJSONStucture = (state, updateData,containerType) => {
    for (let key in updateData) {
        if (updateData.hasOwnProperty(key)) {
            if(key === "parent_id") {
                if(state[key])
                    state[key] = updateData[key];
            }
            else state[key] = updateData[key];
        }
        if(containerType === "tab") {
            if(state.elem_type !== "frame" && !state["sheetFrameElementIndex"]) {
                if(state["elementIndex"])
                state["sheetFrameElementIndex"] = state["elementIndex"];
            }
        }
    }
    if(state?.children){
        for(let i = 0; i < state.children.length; i++) {
            if(state.children[i]) {
                for (let key in updateData) {
                    if (updateData.hasOwnProperty(key)) {
                        if(key === "parent_id") {
                            if(state.children[i][key])
                                state.children[i][key] = updateData[key];
                        }
                        else state.children[i][key] = updateData[key];
                    }
                    if(containerType === "tab") {
                        if(state.children[i].elem_type !== "frame" && !state.children[i]["sheetFrameElementIndex"]) {
                            if(state.children[i]["elementIndex"])
                            state.children[i]["sheetFrameElementIndex"] = state["elementIndex"];
                        }
                    }
                }
                replaceJSONStucture(state.children[i],updateData, containerType);
            }
            else if(state.children[i].subform) {
                replaceJSONStucture(state.children[i].subform,updateData, containerType);
            }
            else if(state?.children[i]?.listviewFrameLayoutJson) {
                replaceJSONStucture(state.children[i].listviewFrameLayoutJson,updateData, containerType);
            }
        }
    }
    else if(state?.length > 0) {
        for(let i = 0; i < state.length; i++) {
            for (let key in updateData) {
                if (updateData.hasOwnProperty(key)) {
                    if(key === "parent_id") {
                        if(state[i][key])
                            state[i][key] = updateData[key];
                    }
                    else state[i][key] = updateData[key];
                }
                if(containerType === "tab") {
                    if(state[i].elem_type !== "frame" && !state[i]["sheetFrameElementIndex"]) {
                        if(state[i]["elementIndex"])
                        state[i]["sheetFrameElementIndex"] = state[i]["elementIndex"];
                    }
                }
            } 
            replaceJSONStucture(state[i],updateData, containerType);      
        }
    }
    else if(state?.tileContents){
        for (let key in updateData) {
            if (updateData.hasOwnProperty(key)) {
                if(key === "parent_id") {
                    if(state[key])
                        state[key] = updateData[key];
                }
                else state[key] = updateData[key];
            }
        if(containerType === "tab") {
            if(state.elem_type !== "frame" && !state["sheetFrameElementIndex"]) {
                if(state["elementIndex"])
                state["sheetFrameElementIndex"] = state["elementIndex"];
            }
        }
        }
        replaceJSONStucture(state?.tileContents,updateData, containerType);      
    }
    return {...state};
}

export const updateTileIndex = (state, updateFrameIndex) => {
    if(state?.elem_type === "tile" && state?.frameIndex){
        state.frameIndex = updateFrameIndex
    }
    if(state?.children){
        for(let i = 0; i < state.children.length; i++) {
            if(state.children[i]) {
                updateTileIndex(state.children[i],updateFrameIndex);
            }
            else if(state.children[i].subform) {
                updateTileIndex(state.children[i].subform,updateFrameIndex);
            }
            else if(state?.children[i]?.listviewFrameLayoutJson) {
                updateTileIndex(state.children[i].listviewFrameLayoutJson,updateFrameIndex);
            }
        }
    }
    else if(state?.length > 0) {
        for(let i = 0; i < state.length; i++) {
            updateTileIndex(state[i],updateFrameIndex);      
        }
    }
    else if(state?.tileContents){
        updateTileIndex(state?.tileContents,updateFrameIndex);      
    }
    return {...state};
}

export const addFrameInBetween = (formState, frameIndex, currentState, position) => {
    if(formState.children) {
        for(let i = 0 ; i < formState.children.length; i++) {
            if(formState.children[i].frameIndex === frameIndex) {
                if(formState.children[i].elem_type === "tab") {
                    formState.children[i].children.push(currentState);
                    swapFrame(formState.children[i].children,position,formState.children.length-1,true);
                }
                else {
                    formState.children.push(currentState);
                    swapFrame(formState.children,frameIndex,formState.children.length-1);
                }
            }
            else if(formState.children[i].subform && formState.children[i].elem_type === "button") {
                addFrameInBetween(formState.children[i].subform,frameIndex,currentState);
            }
            else if(formState.children[i].listviewFrameLayoutJson && formState.children[i].elem_type === "advancelistView") {
                addFrameInBetween(formState.children[i].listviewFrameLayoutJson,frameIndex,currentState);
            }
            else {
                addFrameInBetween(formState.children[i],frameIndex,currentState);
            }
        }
    }
    return {...formState}; 
}

export const findFrame = (formState, frameIndex, position, sheetIndex, ifParentTab) => {
    if(formState.children) { 
        for(let i = 0; i < formState.children.length; i++) {
            if((formState.children[i].id === sheetIndex) || (formState?.children[i]?.tabChildName === sheetIndex && ifParentTab))
            {
                if(ifParentTab)
                swapFrame(formState.children[i].children,parseInt(position),formState.children[i].children[formState.children[i].children.length-1].sheetElementIndex,ifParentTab);
                else 
                swapFrame(formState.children[i].children,parseInt(position),formState.children[i].children.length-1,ifParentTab);
               }
            
            else if(formState?.children[i]?.subform && formState?.children[i]?.elem_type === "button") {
                findFrame(formState.children[i].subform,frameIndex,position, sheetIndex, ifParentTab);
            }
            else if(formState?.children[i]?.listviewFrameLayoutJson && formState?.children[i]?.elem_type === "advancelistView") {
                findFrame(formState.children[i].listviewFrameLayoutJson,frameIndex,position, sheetIndex, ifParentTab);
            }
            else {
                findFrame(formState.children[i],frameIndex,position, sheetIndex, ifParentTab);
            }
        }
    }
    return {...formState};
}

export const relocateControls = (formStatejson, controlId, elem_type, swapControledID, controlEmptyColumnSwapping = false) => {
    relocateControleValue =cloneDeep((formStatejson))
  helper(relocateControleValue, controlId, elem_type, swapControledID)
  let temp = controlReference?.[controleIndex]
  controlReference[controleIndex] =controlReference2?.[controleIndex2]
  controlReference2[controleIndex2] = temp
  let temp2;
  if(!controlEmptyColumnSwapping){
      if(window?.callIdentity === "updatePosition"){
        temp2 = controlReference?.[controleIndex].children[0].elementIndex;
        updateFrameIndex(controlReference?.[controleIndex],controlReference2?.[controleIndex2].children[0].elementIndex, false, true, false);
        updateFrameIndex(controlReference2?.[controleIndex2],temp2, false, true, false);
        }
      else if(window?.callIdentity === "updateframepostion"){
        temp2 = controlReference?.[controleIndex].frameIndex;
        updateFrameIndex(controlReference?.[controleIndex],controlReference2?.[controleIndex2].frameIndex);
        updateFrameIndex(controlReference2?.[controleIndex2],temp2);
      }
      else if(window?.callIdentity === "updateTabFramePosition"){
        temp2 = controlReference?.[controleIndex].sheetElementIndex;
        updateFrameIndex(controlReference?.[controleIndex],controlReference2?.[controleIndex2].sheetElementIndex, true);
        updateFrameIndex(controlReference2?.[controleIndex2],temp2, true);
      }
      else if(window?.callIdentity === "updateTabFrameElementPosition"){
        temp2 = controlReference?.[controleIndex].children[0].sheetFrameElementIndex;
        updateFrameIndex(controlReference?.[controleIndex],controlReference2?.[controleIndex2].children[0].sheetFrameElementIndex, false, false, true);
        updateFrameIndex(controlReference2?.[controleIndex2],temp2, false, false, true);
      }
      else if(window?.callIdentity === "updatePositionForMenuFrameElement"){
        temp2 = controlReference?.[controleIndex].children[0].elementIndex;
        updateFrameIndex(controlReference?.[controleIndex],controlReference2?.[controleIndex2].children[0].elementIndex, false, true);
        updateFrameIndex(controlReference2?.[controleIndex2],temp2, false, true);
      }
      else if(window?.callIdentity === "updatePositionForMenuFrame"){
        temp2 = controlReference?.[controleIndex].frameIndex;
        updateFrameIndex(controlReference?.[controleIndex],controlReference2?.[controleIndex2].frameIndex);
        updateFrameIndex(controlReference2?.[controleIndex2],temp2);
      } else if(window?.callIdentity === "updateTabElementPosition"){
        temp2 = controlReference?.[controleIndex].children[0].sheetElementIndex;
        updateFrameIndex(controlReference?.[controleIndex].children[0],controlReference2?.[controleIndex2]?.children[0]?.sheetElementIndex, true);
        updateFrameIndex(controlReference2?.[controleIndex2]?.children[0],temp2, true);
      }
  }
  return relocateControleValue;
}

 function helper (formStatejson, controlId, elem_type, swapControledID){
    if (formStatejson.children !== undefined && formStatejson.children !== null) {
        for(let i=0; i<formStatejson.children.length;i++){
            if (formStatejson?.children[i]?.id === controlId || formStatejson?.children[i]?.style?.CustomId === controlId) {
                controleIndex=i
                controlReference=formStatejson.children
                
            } 
            if(formStatejson?.children[i]?.id === swapControledID) {
                controleIndex2=i
                controlReference2=formStatejson.children
            }
            else {
                helper(formStatejson.children[i], controlId, elem_type, swapControledID);
            }
        }
    }
}
export function removeAndUpdateComponentInJson(formStatejson, controlId, elem_type) {
    if (formStatejson !== undefined && formStatejson !== null) {
        if (formStatejson.id === controlId) {
        } else {
            if (formStatejson.children !== undefined && formStatejson.children !== null) {
                var children = [];
                formStatejson.children.map(
                    function (entry) {
                        if (entry.id === controlId) {
                            if (entry.elem_type === elem_type) {
                            }
                        } else {
                            var elseReturned = removeAndUpdateComponentInJson(entry, controlId, elem_type);
                            
                            children.push(elseReturned);
                        }
                    }
                );
                formStatejson.children = children;
            }
        }
    }

    return { ...formStatejson };
}

//helper variables used in the repopulation of the frame index, sheet index and element index
var deletedFlag;
var parentIndexVar;
var elementIndexVar;
var elementTypeVar;

//this method needs to be called right after the 'repopulateFrameIndex' function to reset the helper variables o default
export function resetRepopulateFrameIndexVars() {
    deletedFlag = undefined;
    parentIndexVar = undefined;
    elementIndexVar = undefined;
    elementTypeVar = undefined;
}

//this method is called inside deleteElement, when any element say it section, sheet or any control is deleted
//it repopulated the frame index, sheet index and element index
export function repopulateFrameIndex(formStatejson, controlId, elem_type, parentIndex, deleted) {
    deletedFlag = deleted;
    if (deleted !== true) {
        parentIndexVar = parentIndex;
    }
    if (formStatejson !== undefined && formStatejson !== null) {
        if ((formStatejson.elem_type === 'section' ||
            formStatejson.elem_type === 'frame' ||
            formStatejson.elem_type === 'sheet') && deleted !== true) {
            parentIndexVar = formStatejson.frameIndex;
        }
        if (formStatejson.id === controlId) {
            elementIndexVar = formStatejson.elementIndex;
            elementTypeVar = formStatejson.elem_type;
            deletedFlag = true;
        }
        if (formStatejson.children !== undefined && formStatejson.children !== null) {
            var tempId;
            formStatejson.children.map(
                (entry, index) => {
                    if (entry.id === controlId) {
                        elementTypeVar = entry.elem_type;
                        if (entry.elem_type === 'frame' || entry.elem_type === 'section') {
                            tempId = entry.frameIndex;
                        }
                    } else {
                        if (formStatejson.frameIndex) {
                            entry.frameIndex = formStatejson.frameIndex;
                        }
                    }
                    if (tempId) {
                        if (entry.elem_type === 'frame' || entry.elem_type === 'section') {
                            var tempFrameIndex = parseInt(tempId);
                            if (parseInt(entry.frameIndex) > tempFrameIndex) {
                                var currFrameIndex = parseInt(entry.frameIndex);
                                currFrameIndex--;
                                entry.frameIndex = currFrameIndex + '';
                            }
                        }
                    }
                    if (parentIndexVar !== undefined && parentIndexVar !== null && deletedFlag === true) {
                        if (elem_type !== 'frame' && elem_type !== 'section') {
                            if (entry.frameIndex === parentIndexVar) {
                                var elemIndex = entry.elementIndex;
                                if (elemIndex) {
                                    elemIndex = parseInt(elemIndex);
                                    if (elemIndex > parseInt(elementIndexVar)) {
                                        elemIndex--;
                                    }
                                    entry.elementIndex = elemIndex + '';
                                }
                            }
                        }
                    }
                    repopulateFrameIndex(entry, controlId, elem_type, parentIndexVar, deletedFlag);
                }
            );
        }

        if (parentIndexVar !== undefined && parentIndexVar !== null && deletedFlag === true) {
        }
    }

    return formStatejson;
}

export function updateSheetElementIndex(formState, selectedID, elemType) {
    var indexInfo = {};
    recursiveJsonReader(formState, selectedID, elemType, indexInfo);
    updateIndex(formState, indexInfo, "sheetElementIndex");

    return formState;

}

var flag22 = 0
function recursiveJsonReader(jsonData, elemId, elemType, obj, indexToBeDecreasedKey, indexToBeMatchedKey) {

    try {
        if (Array.isArray(jsonData)) {
            const newJsonData = [...jsonData]
            newJsonData.forEach((item, index) => {

                if ((item && item["id"] === elemId)) {
                    console.log('itemToBeDeleted',jsonData);
                    if(elemType === "column"){
                        console.log('itemToBeDeleted',jsonData)
                        if(item.children){
                            if(item.children[0]){
                                if(item.children[0].elementIndex){
                                    obj[indexToBeDecreasedKey] = parseInt(item.children[0][indexToBeDecreasedKey]);
                                }
                            }
                        }
                        if((indexToBeDecreasedKey === "sheetFrameElementIndex" || indexToBeDecreasedKey === "sheetElementIndex") && obj[indexToBeDecreasedKey] !== undefined){
                            obj[indexToBeMatchedKey] = item?.children?.[0]?.[indexToBeMatchedKey]
                        }
                        else{
                        obj[indexToBeMatchedKey] = item[indexToBeMatchedKey]
                        }
                        jsonData.splice(index, 1);
                        obj['updateIndexes'] = true;
                    }
                    else{
                        if(item && item["tileContents"] && item["tileContents"].length === 1){
                            console.log('itemToBeDeleted',jsonData)
                            if(item["tileContents"][0] !== undefined)
                            if(item["tileContents"][0][indexToBeDecreasedKey] !== undefined)
                                obj[indexToBeDecreasedKey] = item["tileContents"][0][indexToBeDecreasedKey]
                            
                            if(indexToBeDecreasedKey === "sheetFrameElementIndex" && obj[indexToBeDecreasedKey] !== undefined){
                                flag22 = 1
                            }
                        }
                        else{
                            console.log('itemToBeDeleted',jsonData)
                        obj[indexToBeDecreasedKey] = parseInt(item[indexToBeDecreasedKey]);
                        }

                        if(flag22 === 0){
                        obj[indexToBeMatchedKey] = item[indexToBeMatchedKey]
                        }
                        else{
                            obj[indexToBeMatchedKey] = item?.tileContents?.[0]?.[indexToBeMatchedKey]
                        }
                        jsonData.splice(index, 1);
                        obj['updateIndexes'] = true;
                    }
                }
                if (obj?.updateIndexes === true) {
                    if ((item[indexToBeMatchedKey] !== undefined) && (parseInt(item[indexToBeMatchedKey]) === parseInt(obj[indexToBeMatchedKey]))) {
                        let int_indexToBeDecreasedKey = parseInt(item[indexToBeDecreasedKey]);
                        if (int_indexToBeDecreasedKey > parseInt(obj[indexToBeDecreasedKey])) {
                            item[indexToBeDecreasedKey] = (parseInt(item[indexToBeDecreasedKey]) - 1) + '';
                            item["visited1"] = true
                        }
                    } else if (indexToBeMatchedKey === "RootControl" && (item ?.elem_type === elemType)) {
                        let int_indexToBeDecreasedKey = parseInt(item[indexToBeDecreasedKey]);
                        if (int_indexToBeDecreasedKey > parseInt(obj[indexToBeDecreasedKey])) {
                            item[indexToBeDecreasedKey] = parseInt(item[indexToBeDecreasedKey]) - 1 + "";
                            item["visited1"] = true
                        }
                    } else if (item ?.elem_type === 'row' || item ?.elem_type === 'column') {
                        let int_indexToBeDecreasedKey = parseInt(item[indexToBeDecreasedKey]);
                        if (int_indexToBeDecreasedKey > parseInt(obj[indexToBeDecreasedKey])) {
                            item[indexToBeDecreasedKey] = parseInt(item[indexToBeDecreasedKey]) - 1 + "";
                            item["visited1"] = true
                        }
                    }
                    else if ((
                        item ?.elem_type === 'textbox' ||
                        item ?.elem_type === 'datepick' ||
                        item ?.elem_type === 'combo' ||
                        item ?.elem_type === 'checkbox' ||
                        item ?.elem_type === 'radio' ||
                        item ?.elem_type === 'button' ||
                        item ?.elem_type === 'textarea' ||
                        item ?.elem_type === 'multiSelect' ||
                        item ?.elem_type === 'label' ||
                        item ?.elem_type === 'iframe' ||
                        item ?.elem_type === 'paragraph' ||
                        item ?.elem_type === 'image' ||
                        item ?.elem_type === 'richtexteditor' ||
                        item ?.elem_type === 'toggle' ||
                        item ?.elem_type === 'imagecarousel' ||
                        item ?.elem_type === 'link' ||
                        item ?.elem_type === 'slider' ||
                        item ?.elem_type === 'doclist' ||
                        item ?.elem_type === 'email' ||
                        item ?.elem_type === 'password' ||
                        item ?.elem_type === 'percentage' ||
                        item ?.elem_type === 'phonenumber' ||
                        item ?.elem_type === 'picklist' ||
                        item ?.elem_type === 'listbox' ||
                        item ?.elem_type === 'report' ||
                        item ?.elem_type === 'CustomControl' ||
                        item ?.elem_type === 'captcha' ||
                        item ?.elem_type === 'listview' ||
                        item ?.elem_type === 'table' ||
                        item ?.elem_type === 'advancelistview' 
                    ) && (parseInt(item[indexToBeMatchedKey]) === parseInt(obj[indexToBeMatchedKey]))) {     
                        let int_indexToBeDecreasedKey = parseInt(item[indexToBeDecreasedKey]);
                        if (int_indexToBeDecreasedKey > parseInt(obj[indexToBeDecreasedKey])) {
                            item[indexToBeDecreasedKey] = parseInt(item[indexToBeDecreasedKey]) - 1 + "";
                            item["visited1"] = true
                        }
                    }
                    else if ((
                        item ?.elem_type === 'textbox' ||
                        item ?.elem_type === 'datepick' ||
                        item ?.elem_type === 'combo' ||
                        item ?.elem_type === 'checkbox' ||
                        item ?.elem_type === 'radio' ||
                        item ?.elem_type === 'button' ||
                        item ?.elem_type === 'textarea' ||
                        item ?.elem_type === 'multiSelect' ||
                        item ?.elem_type === 'tab' ||
                        item ?.elem_type === 'label' ||
                        item ?.elem_type === 'iframe' ||
                        item ?.elem_type === 'paragraph' ||
                        item ?.elem_type === 'image' ||
                        item ?.elem_type === 'richtexteditor' ||
                        item ?.elem_type === 'wizard_h' ||
                        item ?.elem_type === 'wizard_v' ||
                        item ?.elem_type === 'sidenavigation' ||
                        item ?.elem_type === 'sheet' ||
                        item ?.elem_type === 'toggle' ||
                        item ?.elem_type === 'imagecarousel' ||
                        item ?.elem_type === 'link' ||
                        item ?.elem_type === 'slider' ||
                        item ?.elem_type === 'doclist' ||
                        item ?.elem_type === 'email' ||
                        item ?.elem_type === 'password' ||
                        item ?.elem_type === 'percentage' ||
                        item ?.elem_type === 'phonenumber' ||
                        item ?.elem_type === 'picklist' ||
                        item ?.elem_type === 'listbox' ||
                        item ?.elem_type === 'report' ||
                        item ?.elem_type === 'CustomControl' ||
                        item ?.elem_type === 'captcha' ||
                        item ?.elem_type === 'Menu' || 
                        item ?.elem_type === 'listview' ||
                        item ?.elem_type === 'table' ||
                        item ?.elem_type === 'advancelistview' 
                    ) && indexToBeMatchedKey === "RootControl") {     
                        let int_indexToBeDecreasedKey = parseInt(item[indexToBeDecreasedKey]);
                        if (int_indexToBeDecreasedKey > parseInt(obj[indexToBeDecreasedKey])) {
                            item[indexToBeDecreasedKey] = parseInt(item[indexToBeDecreasedKey]) - 1 + "";
                            item["visited1"] = true
                        }
                    }
                    
                }
                if (item && Object.keys(item).includes("children")) {
                    obj = recursiveJsonReader(item, elemId, elemType, obj, indexToBeDecreasedKey, indexToBeMatchedKey);
                }

                if (item && item["tileContents"]) {
                    
                    obj = recursiveJsonReader(item["tileContents"], elemId, elemType, obj, indexToBeDecreasedKey, indexToBeMatchedKey);
                }

            })
        } else {

            if (jsonData && jsonData["id"] !== elemId) {
                obj = recursiveJsonReader(jsonData["children"], elemId, elemType, obj, indexToBeDecreasedKey, indexToBeMatchedKey);

            }
            else { 
                if((obj.elementIndex === undefined || obj.elementIndex === null) && (obj?.sheetElementIndex === undefined || obj?.sheetElementIndex === null)){
                obj[indexToBeDecreasedKey] = parseInt(jsonData[indexToBeDecreasedKey]);
                obj[indexToBeMatchedKey] = jsonData[indexToBeMatchedKey]
                }
            }
        }
        return (obj);
    } catch (e) {

    }
}

export function saveSectionAsTemplate(templateDetails, templateID) {
    try {
        var jsonToSend = templateDetails;
        var remainingURL = '/templates/';
        return axios.post(remainingURL, jsonToSend, { withCredentials: true })
    }
    catch (err) {
        console.log(err);
    }
}


export function findSuccessAndErrorMessageControlsBasedOnAttribute(jsonData, attributeName, successErrorMessageControlDetailsJson) {
    try {
        if (Array.isArray(jsonData)) {
            jsonData.forEach((item, index) => {

                if (item && item["style"] && item["style"]["Mandatory"] == "true") {
                    successErrorMessageControlDetailsJson.push(item["id"]);
                }
                if (item && Object.keys(item).includes("children")) {
                    successErrorMessageControlDetailsJson = findSuccessAndErrorMessageControlsBasedOnAttribute(item, attributeName, successErrorMessageControlDetailsJson);
                }
            })
        } else {

            if (jsonData && jsonData["style"] && jsonData["style"]["Mandatory"] == "true") {
                successErrorMessageControlDetailsJson.push(jsonData["id"]);
            }
            if (jsonData && Object.keys(jsonData).includes("children")) {
                successErrorMessageControlDetailsJson = findSuccessAndErrorMessageControlsBasedOnAttribute(jsonData["children"], attributeName, successErrorMessageControlDetailsJson);
            }
        }
        return (successErrorMessageControlDetailsJson);
    }
    catch (err) {
        console.log(err);
    }
}

export function deleteColumnFromJson(json, key) {
    // loop all rows (c), not just row 0 — fix hardcoded children[0]
    for(let c = 0; c < json.children.length; c++) {
        for(let i = 0; i < json.children[c].children.length; i++) {
                if(json.children[c]?.children[i]?.children[0]?.isSubFrame && json.children[c]?.children[i]?.children[0]?.children){
                    deleteColumnFromJson(json.children[c].children[i].children[0], key)
                }
                if(json.children[c]?.children[i]?.children[0]?.elem_type === "row" && json.children[c]?.children[i]?.children[0]?.children){
                    deleteColumnFromJson(json.children[c].children[i], key)
                }
                if(json.children[c]?.children[i]?.children[0]?.elem_type === "column" && json.children[c]?.children[i]?.children[0]?.children){
                    deleteColumnFromJson(json.children[c], key)
                }
                if(json?.children[c]?.children?.[i]?.["id"] === key) {
                    json.children[c].children.splice(i--,1);
                }
        }
    }
}

export function handleDeleteFromRow(rowJson, key, index) {
    for(let i = 0; i < rowJson.children.length; i++) {
        for(let j = 0; j < rowJson.children[i].children.length; j++) {
                if(rowJson.children[i].children[j].elem_type === 'row') {
                    handleDeleteFromRow(rowJson.children[i].children[j], key, index);
                }
                if(rowJson.children[i].children[j].elem_type === 'tile') {
                    let tileContents = rowJson.children[i].children[j].tileContents;
                    for(let l = 0 ; l < tileContents.length; l++) {
                        if(tileContents[l][key]?.toString() === index?.toString()) {
                            tileContents.splice(l--,1);
                        }
                        else if(parseInt(tileContents[l][key]) > parseInt(index)) {
                            tileContents[l][key] = parseInt(tileContents[key] - 1) + "";
                        }
                    }
                }
                if(parseInt(rowJson.children[i].children[j][key]) > parseInt(index)) {
                    rowJson.children[i].children[j][key] = (parseInt(rowJson.children[i].children[j][key]) - 1) + "";
                    if(rowJson.children[i].children[j].elem_type === 'tile') {
                        let tileContents = rowJson.children[i].children[j].tileContents;
                        for(let l = 0 ; l < tileContents.length; l++) {
                            tileContents[l][key] = parseInt(tileContents[l][key] - 1)                            
                        }
                    } 
                    if(rowJson.children[i].children[j].elem_type === 'frame') {
                        updateIndexInFrame(rowJson.children[i].children[j],rowJson.children[i].children[j][key],key);
                    }
                    
                } else if(parseInt(rowJson.children[i].children[j][key]) === parseInt(index)) {
                    rowJson.children[i].children.splice(j--,1);
                }
        }
    }
}

export function updateSheetElementIndexesInFrames(json){
    if(json){
        if(json.sheetElementIndex && json?.sheetElementIndex !== undefined){
            json.sheetElementIndex = (parseInt(json?.sheetElementIndex) - 1) + "";
        }
        if(json?.children[0]?.sheetElementIndex && json?.children[0]?.sheetElementIndex !== undefined){
            json.children[0].sheetElementIndex = (parseInt(json.children[0]?.sheetElementIndex) - 1) + "";
        }
        for(let i = 0; i < json.children[0].children.length; i++) {
            if(json?.children?.[0]?.children?.[i]?.sheetElementIndex && json?.children?.[0]?.children?.[i]?.sheetElementIndex !== undefined){
                json.children[0].children[i].sheetElementIndex = (parseInt(json?.children?.[0]?.children?.[i]?.sheetElementIndex) - 1) + "";
            }
            for(let j = 0; j < json.children[0].children[i].children.length; j++) {
                // for(let k = 0; k < json.children[0].children[i].children[j].length; k++) {
                    // if(json.children[0].children[i].children[j].isSubFrame && json.children[0].children[i].children[j].children){
                    //     updateSheetElementIndexesInFrames(json.children[0].children[i].children[j])
                    // }
                    if(json.children[0].children[i].children[j].elem_type === 'tile') {
                        if(json.children[0].children[i].children[j]?.sheetElementIndex && json.children[0].children[i].children[j]?.sheetElementIndex !== undefined)
                        json.children[0].children[i].children[j].sheetElementIndex = (parseInt(json.children[0].children[i].children[j]?.sheetElementIndex) - 1) + "";
                        let tileContents = json.children[0].children[i].children[j].tileContents;

                        for(let l = 0 ; l < tileContents.length; l++) {
                            if(tileContents?.[l]?.sheetElementIndex && tileContents?.[l]?.sheetElementIndex !== undefined)
                            tileContents[l].sheetElementIndex = (parseInt(tileContents?.[l]?.sheetElementIndex) - 1) + "";
                        }
                    }
                    else{
                        if(json.children[0].children[i].children[j] && json.children[0].children[i].children[j]?.sheetElementIndex !== undefined)
                        json.children[0].children[i].children[j].sheetElementIndex = (parseInt(json.children[0].children[i].children[j]?.sheetElementIndex) - 1) + "";
                    }
                // }
            }
        }
    }
}

export function updateFrameIndexesInFrames(json){
    if(json){
        if(json.frameIndex && json?.frameIndex !== undefined){
            json.frameIndex = (parseInt(json?.frameIndex) - 1) + "";
        }
        if(json?.children[0]?.frameIndex && json?.children[0]?.frameIndex !== undefined){
            json.children[0].frameIndex = (parseInt(json.children[0]?.frameIndex) - 1) + "";
        }
        for(let i = 0; i < json.children[0].children.length; i++) {
            if(json?.children?.[0]?.children?.[i]?.frameIndex && json?.children?.[0]?.children?.[i]?.frameIndex !== undefined){
                json.children[0].children[i].frameIndex = (parseInt(json?.children?.[0]?.children?.[i]?.frameIndex) - 1) + "";
            }
            for(let j = 0; j < json.children[0].children[i].children.length; j++) {
                // for(let k = 0; k < json.children[0].children[i].children[j].length; k++) {
                    if(json.children[0].children[i].children[j].isSubFrame && json.children[0].children[i].children[j].children){
                        updateFrameIndexesInFrames(json.children[0].children[i].children[j])
                    }
                    else if(json.children[0].children[i].children[j].elem_type === 'tile') {
                        if(json.children[0].children[i].children[j]?.frameIndex && json.children[0].children[i].children[j]?.frameIndex !== undefined)
                        json.children[0].children[i].children[j].frameIndex = (parseInt(json.children[0].children[i].children[j]?.frameIndex) - 1) + "";
                        let tileContents = json.children[0].children[i].children[j].tileContents;

                        for(let l = 0 ; l < tileContents.length; l++) {
                            if(tileContents?.[l]?.frameIndex && tileContents?.[l]?.frameIndex !== undefined)
                            tileContents[l].frameIndex = (parseInt(tileContents?.[l]?.frameIndex) - 1) + "";
                        }
                    }
                    else{
                        if(json.children[0].children[i].children[j] && json.children[0].children[i].children[j]?.frameIndex !== undefined)
                        json.children[0].children[i].children[j].frameIndex = (parseInt(json.children[0].children[i].children[j]?.frameIndex) - 1) + "";
                    }
                // }
            }
        }
    }
}

export function updateElementIndexesInFrames(json){
    if(json){
        if(json.elementIndex && json?.elementIndex !== undefined){
            json.elementIndex = (parseInt(json?.elementIndex) - 1) + "";
        }
        if(json?.children[0]?.elementIndex && json?.children[0]?.elementIndex !== undefined){
            json.children[0].elementIndex = (parseInt(json.children[0]?.elementIndex) - 1) + "";
        }
        for(let i = 0; i < json.children[0].children.length; i++) {
            if(json?.children?.[0]?.children?.[i]?.elementIndex && json?.children?.[0]?.children?.[i]?.elementIndex !== undefined){
                json.children[0].children[i].elementIndex = (parseInt(json?.children?.[0]?.children?.[i]?.elementIndex) - 1) + "";
            }
            for(let j = 0; j < json.children[0].children[i].children.length; j++) {
                // for(let k = 0; k < json.children[0].children[i].children[j].length; k++) {
                    if(json.children[0].children[i].children[j].isSubFrame && json.children[0].children[i].children[j].children){
                        updateElementIndexesInFrames(json.children[0].children[i].children[j])
                    }
                    else if(json.children[0].children[i].children[j].elem_type === 'tile') {
                        if(json.children[0].children[i].children[j]?.elementIndex && json.children[0].children[i].children[j]?.elementIndex !== undefined)
                        json.children[0].children[i].children[j].elementIndex = (parseInt(json.children[0].children[i].children[j]?.elementIndex) - 1) + "";
                        let tileContents = json.children[0].children[i].children[j].tileContents;

                        for(let l = 0 ; l < tileContents.length; l++) {
                            if(tileContents?.[l]?.elementIndex && tileContents?.[l]?.elementIndex !== undefined)
                            tileContents[l].elementIndex = (parseInt(tileContents?.[l]?.elementIndex) - 1) + "";
                        }
                    }
                    else{
                        if(json.children[0].children[i].children[j] && json.children[0].children[i].children[j]?.elementIndex !== undefined)
                        json.children[0].children[i].children[j].elementIndex = (parseInt(json.children[0].children[i].children[j]?.elementIndex) - 1) + "";
                    }
                // }
            }
        }
    }
}

export function updateFrameIndexesInTab(json){
    if(json){
        if(json.frameIndex && json?.frameIndex !== undefined){
            json.frameIndex = (parseInt(json?.frameIndex) - 1) + "";
        }
        if(json?.children[0]?.frameIndex && json?.children[0]?.frameIndex !== undefined){
            json.children[0].frameIndex = (parseInt(json.children[0]?.frameIndex) - 1) + "";
        }
        for(let i = 0; i < json.children[0].children.length; i++) {
            updateFrameIndexesInTabSheets(json.children[0].children[i])
            // break;
        }
    }
}

export function updateFrameIndexesInTabSheets(sheetJson){
    if(sheetJson){
        if(sheetJson.frameIndex && sheetJson?.frameIndex !== undefined){
            sheetJson.frameIndex = (parseInt(sheetJson?.frameIndex) - 1) + "";
        }
        for(let i = 0; i < sheetJson.children.length; i++) {
            if(sheetJson?.children?.[i].frameIndex && sheetJson?.children?.[i].frameIndex !== undefined){
                sheetJson.children[i].frameIndex = (parseInt(sheetJson?.children?.[i].frameIndex) - 1) + "";
            }
            if(sheetJson.children[i].elem_type === "row") {
                for(let j = 0; j < sheetJson.children[i].children.length; j++) {
                    if(sheetJson?.children[i]?.children[j]?.frameIndex && sheetJson?.children[i]?.children[j]?.frameIndex !== undefined){
                        sheetJson.children[i].children[j].frameIndex = (parseInt(sheetJson?.children[i]?.children[j]?.frameIndex) - 1) + "";
                    }
                    for(let k = 0; k < sheetJson?.children[i]?.children[j]?.children?.length; k++) {
                        if(sheetJson?.children[i]?.children[j]?.children[k]?.frameIndex && sheetJson?.children[i]?.children[j]?.children[k]?.frameIndex !== undefined){
                            sheetJson.children[i].children[j].children[k].frameIndex = (parseInt(sheetJson?.children[i]?.children[j]?.children[k]?.frameIndex) - 1) + "";
                        }
                        if(sheetJson.children[i].children[j]?.children[k]?.elem_type === "frame") {
                            if(sheetJson?.children[i]?.children[j]?.children[k]?.frameIndex && sheetJson?.children[i]?.children[j]?.children[k]?.frameIndex !== undefined){
                                sheetJson.children[i].children[j].children[k].frameIndex = (parseInt(sheetJson?.children[i]?.children[j]?.children[k]?.frameIndex) + 1) + "";
                            }
                            updateFrameIndexesInFrames(sheetJson.children[i].children[j]?.children[k]);
                        }
                        try{
                            if(sheetJson.children[i].children[j]?.children[k]?.sheetElementIndex) {
                                if(sheetJson.children[i].children[j]?.children[k]?.elem_type === 'tile') {
                                    let tileContents = sheetJson.children[i].children[j]?.children[k]?.tileContents;
                                    // if(sheetJson.children[i].children[j]?.children[k]?.frameIndex && sheetJson.children[i].children[j]?.children[k]?.frameIndex !== undefined)
                                    //     sheetJson.children[i].children[j].children[k].frameIndex = (parseInt(sheetJson.children[i].children[j]?.children[k]?.frameIndex) - 1) + "";
                                    for(let l = 0 ; l < tileContents.length; l++) {
                                        if(tileContents?.[l]?.["frameIndex"] && tileContents?.[l]?.["frameIndex"] !== undefined) {
                                            tileContents[l]["frameIndex"] = parseInt(tileContents?.[l]?.["frameIndex"] - 1) + "";
                                        }
                                    }
                                }
                            }
                        }
                        catch(e){
                            console.log(e, "kyu1")
                        }
                    }
                }
            }
            else if(sheetJson?.children[i]?.elem_type === "frame") {
                if(sheetJson?.children?.[i].frameIndex && sheetJson?.children?.[i].frameIndex !== undefined){
                    sheetJson.children[i].frameIndex = (parseInt(sheetJson?.children?.[i].frameIndex) + 1) + "";
                }
                updateFrameIndexesInFrames(sheetJson.children[i]);
            }
        }
    }
}

export function updateElementIndexesInTab(json){
    if(json){
        if(json.elementIndex && json?.elementIndex !== undefined){
            json.elementIndex = (parseInt(json?.elementIndex) - 1) + "";
        }
        for(let i = 0; i < json.children.length; i++) {
            updateElementIndexesInTabSheets(json.children[i])
            // break;
        }
    }
}

export function updateElementIndexesInTabSheets(sheetJson){
    if(sheetJson){
        if(sheetJson.elementIndex && sheetJson?.elementIndex !== undefined){
            sheetJson.elementIndex = (parseInt(sheetJson?.elementIndex) - 1) + "";
        }
        for(let i = 0; i < sheetJson.children.length; i++) {
            if(sheetJson?.children?.[i].elementIndex && sheetJson?.children?.[i].elementIndex !== undefined){
                sheetJson.children[i].elementIndex = (parseInt(sheetJson?.children?.[i].elementIndex) - 1) + "";
            }
            if(sheetJson.children[i].elem_type === "row") {
                for(let j = 0; j < sheetJson.children[i].children.length; j++) {
                    if(sheetJson?.children[i]?.children[j]?.elementIndex && sheetJson?.children[i]?.children[j]?.elementIndex !== undefined){
                        sheetJson.children[i].children[j].elementIndex = (parseInt(sheetJson?.children[i]?.children[j]?.elementIndex) - 1) + "";
                    }
                    for(let k = 0; k < sheetJson?.children[i]?.children[j]?.children?.length; k++) {
                        if(sheetJson?.children[i]?.children[j]?.children[k]?.elementIndex && sheetJson?.children[i]?.children[j]?.children[k]?.elementIndex !== undefined){
                            sheetJson.children[i].children[j].children[k].elementIndex = (parseInt(sheetJson?.children[i]?.children[j]?.children[k]?.elementIndex) - 1) + "";
                        }
                        if(sheetJson.children[i].children[j]?.children[k]?.elem_type === "frame") {
                            if(sheetJson?.children[i]?.children[j]?.children[k]?.elementIndex && sheetJson?.children[i]?.children[j]?.children[k]?.elementIndex !== undefined){
                                sheetJson.children[i].children[j].children[k].elementIndex = (parseInt(sheetJson?.children[i]?.children[j]?.children[k]?.elementIndex) + 1) + "";
                            }
                            updateElementIndexesInFrames(sheetJson.children[i].children[j]?.children[k]);
                        }
                        try{
                            if(sheetJson.children[i].children[j]?.children[k]?.sheetElementIndex) {
                                if(sheetJson.children[i].children[j]?.children[k]?.elem_type === 'tile') {
                                    let tileContents = sheetJson.children[i].children[j]?.children[k]?.tileContents;
                                    // if(sheetJson.children[i].children[j]?.children[k]?.elementIndex && sheetJson.children[i].children[j]?.children[k]?.elementIndex !== undefined)
                                    //     sheetJson.children[i].children[j].children[k].elementIndex = (parseInt(sheetJson.children[i].children[j]?.children[k]?.elementIndex) - 1) + "";
                                    for(let l = 0 ; l < tileContents.length; l++) {
                                        if(tileContents?.[l]?.["elementIndex"] && tileContents?.[l]?.["elementIndex"] !== undefined) {
                                            tileContents[l]["elementIndex"] = parseInt(tileContents?.[l]?.["elementIndex"] - 1) + "";
                                        }
                                    }
                                }
                            }
                        }
                        catch(e){
                            console.log(e, "kyu1")
                        }
                    }
                }
            }
            else if(sheetJson?.children[i]?.elem_type === "frame") {
                if(sheetJson?.children?.[i].elementIndex && sheetJson?.children?.[i].elementIndex !== undefined){
                    sheetJson.children[i].elementIndex = (parseInt(sheetJson?.children?.[i].elementIndex) + 1) + "";
                }
                updateElementIndexesInFrames(sheetJson.children[i]);
            }
        }
    }
}

export function deleteControlAndUpdateIndex(json, key, index) {
    for(let c = 0; c < json.children.length; c++) {
        for(let i = 0; i < json.children[c].children.length; i++) {
            for(let j = 0; j < json.children[c].children[i].children.length; j++) {
                    if(json.children[c].children[i].children[j].elem_type === 'row') {
                        handleDeleteFromRow(json.children[c].children[i].children[j], key, index);
                    }
                    if(json.children[c].children[i].children[j].elem_type === 'tile') {
                        let tileContents = json.children[c].children[i].children[j].tileContents;
                        for(let l = 0 ; l < tileContents.length; l++) {
                            if(tileContents[l][key]?.toString() === index?.toString()) {
                                tileContents.splice(l--,1);
                            }
                            else if(parseInt(tileContents[l][key]) > parseInt(index)) {
                                tileContents[l][key] = parseInt(tileContents[l][key] - 1) + "";
                            }
                        }
                    }
                    if(parseInt(json.children[c].children[i].children[j][key]) > parseInt(index)) {
                        if(json.children[c].children[i].children[j]?.elem_type === "tab"){
                                updateElementIndexesInTab(json.children[c].children[i].children[j])
                            }
                            else{
                                json.children[c].children[i].children[j][key] = (parseInt(json.children[c].children[i].children[j][key]) - 1) + "";
                                if(json.children[c].children[i].children[j].elem_type === 'tile') {
                                    let tileContents = json.children[c].children[i].children[j].tileContents;
                                    for(let l = 0 ; l < tileContents.length; l++) {
                                        tileContents[l][key] = parseInt(tileContents[l][key] - 1) + "";
                                    }
                                } 
                            }
                        
                    } else if(parseInt(json.children[c].children[i].children[j][key]) === parseInt(index)) {
                        json.children[c].children[i].children.splice(j--,1);
                    }
            }
        }
    }
}

function updateIndexInFrame(frameJson, index,key) {
    // for (let item of frameJson.child) {
    //     if (item.elem_type === "tab") {
    //       if(index)
    //         item[key] = index + "";
    //       updateIndexInTab(item.children, frameIndex,count);
    //     }
    //     if(item.elem_type === "frame") {
    //       if(index)
    //         item[key] = index + "";
    //       updateElementsInSubFrame(item.children,frameIndex, count);
    //       subFrameElementIndex = 0;
    //       count++;
    //     }
    //     if (!item.children) {
    //       item.elementIndex = count + "";
    //       if(frameIndex)
    //         item.frameIndex = frameIndex + "";
    //       if(item.tileContents) {
    //         for(const element of item.tileContents) {
    //             element.elementIndex = count + "";
    //             if(frameIndex)
    //               element.frameIndex = frameIndex + "";
    //             count++;
    //         }
    //       } else {
    //           count++;
    //       }
    //     }
    //     if (item.children && item.elem_type !== 'tab' && item.elem_type !== "frame") {
    //       if(item.elem_type === 'row' || item.elem_type === 'column') {
    //         if(frameIndex) {
    //           item.frameIndex = frameIndex + ""; 
    //         }
    //       } 
    //       updateElementsInFrame(item.children,frameIndex);
    //     }
    //   }
    if(frameJson.children) {
        frameJson[key] = index;
        for(let i = 0; i < frameJson.children.length; i++) {
            if(frameJson.children[i].children) {
                frameJson.children[i][key] = index;
                updateIndexInFrame(frameJson.children[i],index,key);
            } else {
                frameJson.children[i][key] = index;
                if(frameJson.children[i].elem_type === 'tile') {
                    let tileContents = frameJson.children[i].tileContents;
                    for(let l = 0 ; l < tileContents.length; l++) {
                        tileContents[l][key] = index; 
                    }
                }
            }
        }
    }
    else {
        frameJson[key] = index;
        if(frameJson.elem_type === 'tile') {
            let tileContents = frameJson.tileContents;
            for(let l = 0 ; l < tileContents.length; l++) {
                tileContents[l][key] = index; 
            }
        }
    }
}

function fixWizardDeletionIndexes(wizardJson, stepJson, responseData) {
    if(responseData && responseData.elem_type === "column"){
        let frameJson;
        for(let i = 0 ; i < stepJson.children.length; i++) {
            if(stepJson.children[i]?.frameIndex?.toString() === responseData?.frameIndex?.toString()) {
                frameJson = stepJson.children[i];
                break;
            }
        }
        deleteColumnFromJson(frameJson, responseData.id);
    }
    else if(responseData.elementIndex || responseData?.elementIndex === 0) {
        let frameJson;
        for(let i = 0; i < stepJson.children.length; i++) {
            if(stepJson.children[i].frameIndex?.toString() === responseData.frameIndex?.toString()) {
                frameJson = stepJson.children[i];
                break;
            }
        }
        // deleteControlAndUpdateIndex(frameJson,"elementIndex",responseData.elementIndex);
        if(responseData?.subFrameElementIndex || responseData?.subFrameElementIndex === 0){
            let updateFrameJson;
            for(let i = 0; i < frameJson.children[0].children.length; i++) {
                for(let j = 0; j < frameJson.children[0].children[i].children.length; j++) {
                    if(frameJson.children[0].children[i].children[j].elementIndex?.toString() === responseData.elementIndex?.toString()) {
                        updateFrameJson = frameJson.children[0].children[i].children[j];
                        break;
                    }
                }
            }
            deleteControlAndUpdateIndex(updateFrameJson,"subFrameElementIndex",responseData.subFrameElementIndex);
        }
        else{
            deleteControlAndUpdateIndex(frameJson,"elementIndex",responseData.elementIndex);
        }
    } else if(responseData.frameIndex) {
        for(let i = 0; i < stepJson.children.length; i++) {
            if(parseInt(stepJson?.children[i]?.frameIndex) > parseInt(responseData?.frameIndex)) {
                stepJson.children[i].frameIndex = (parseInt(stepJson?.children[i]?.frameIndex) - 1) + "";
                updateIndexInFrame(stepJson.children[i],stepJson.children[i].frameIndex,"frameIndex");
            } else if(parseInt(stepJson?.children[i]?.frameIndex) === parseInt(responseData?.frameIndex)) {
                stepJson?.children.splice(i--,1);
                // if(i !== 0){
                //     i--
                // }
                // else{
                //     i = 0
                // }
            }
        }
    } else {
        if(responseData.subChildMenuIndex && responseData.subChildMenuIndex !== '-1') {
            for(let i = 0; i < wizardJson.children.length; i++) {
                if(wizardJson.children[i].stepIndex?.toString() === responseData.stepIndex?.toString()) {
                    for(let j = 0; j < wizardJson.children[i].children.length ; j++) {
                        if(wizardJson.children[i].children[j].subStepIndex?.toString() === responseData.subStepIndex?.toString()) {
                            for(let k = 0; k < wizardJson.children[i].children[j].children.length; k++) {
                                if(wizardJson.children[i].children[j].children[k].subChildMenuIndex?.toString() === responseData.subChildMenuIndex?.toString()) {                                    
                                    wizardJson.children[i].children[j].children.splice(k--,1);
                                }
                                if(parseInt(wizardJson.children[i].children[j].children[k].subChildMenuIndex) > parseInt(wizardJson.children[i].children[j].children[k].subChildMenuIndex)) {
                                    wizardJson.children[i].children[j].children[k].subChildMenuIndex = (parseInt(wizardJson.children[i].children[j].children[k].subChildMenuIndex) - 1) + "";  
                                }
                            }
                        }
                    }
                    break;
                }
            }
        }
        else if(responseData.subStepIndex && responseData.subStepIndex !== '-1') {
            for(let i = 0; i < wizardJson.children.length; i++) {
                if(wizardJson.children[i].stepIndex?.toString() === responseData.stepIndex?.toString()) {
                    for(let j = 0; j < wizardJson.children[i].children.length ; j++) {
                        if(wizardJson.children[i].children[j].subStepIndex?.toString() === responseData.subStepIndex?.toString()) {
                            wizardJson.children[i].children[j].splice(j--,1);
                        }
                        else if(parseInt(wizardJson.children[i].children[j].subStepIndex) > parseInt(responseData.subStepIndex)) {
                            wizardJson.children[i].children[j].subStepIndex = (parseInt(wizardJson.children[i].children[j].subStepIndex) - 1) + "";  
                        }
                    }
                    break;
                }
            }
        }
        else {
            for(let i = 0; i < wizardJson.children.length; i++) {
                if(wizardJson.children[i].stepIndex?.toString() === responseData.stepIndex?.toString()) {
                    wizardJson.children.splice(i--,1);
                }
                if(parseInt(wizardJson.children[i].stepIndex) > parseInt(responseData.stepIndex)) {
                    wizardJson.children[i].stepIndex = (parseInt(wizardJson.children[i].stepIndex) - 1) + "";  
                }
            }  
        }
    };
}

function deleteFromSheetColumn(columnJson,responseData) {
    for(let j = 0; j < columnJson.children.length; j++) {
        if(columnJson.children[j]?.elem_type === "frame" && responseData.sheetFrameElementIndex && responseData.sheetElementIndex === columnJson.children[j].sheetElementIndex) {
            deleteControlAndUpdateIndex(columnJson.children[j],"sheetFrameElementIndex",responseData.sheetFrameElementIndex);
            break;
        }
        if((columnJson.children[j].sheetElementIndex?.toString() === responseData.sheetElementIndex?.toString()) && !responseData.sheetFrameElementIndex) {
            if(columnJson.children[j].elem_type === 'tile') {
                let tileContents = columnJson.children[j].tileContents;
                for(let l = 0 ; l < tileContents.length; l++) {
                    if(tileContents?.[l]?.["sheetElementIndex"]?.toString() === responseData.sheetElementIndex?.toString()) {
                        tileContents.splice(l--,1);
                    }
                    else if(parseInt(tileContents?.[l]?.["sheetElementIndex"]) > parseInt(responseData.sheetElementIndex)) {
                        tileContents[l]["sheetElementIndex"] = parseInt(tileContents[l]["sheetElementIndex"] - 1) + "";
                    }
                }
            }
            columnJson.children.splice(j--,1);
        }
        else if((parseInt(columnJson.children[j].sheetElementIndex) > parseInt(responseData.sheetElementIndex)) && !responseData.sheetFrameElementIndex) {
            columnJson.children[j].sheetElementIndex = (parseInt(columnJson.children[j].sheetElementIndex) - 1) + "";
            if(columnJson.children[j].elem_type === 'tile') {
                let tileContents = columnJson.children[j].tileContents;
                for(let l = 0 ; l < tileContents.length; l++) {
                    tileContents[l].sheetElementIndex = parseInt(tileContents[l].sheetElementIndex) - 1; 
                }
            }
            else if(columnJson.children[j].elem_type === 'frame') {
                updateIndexInFrame(columnJson.children[j],columnJson.children[j].sheetElementIndex,"sheetElementIndex");
            }
        }
    }
}

const findWizardIndex = (child) => {
    for(let i = 0; i < child.length; i++){
      if(child[i].id === "wizard"){
        return i;
      }
    }
    return -1;
  }

export function removeAndUpdateIndex(formState,responseData) {
 
    // const formState = getFormJsonFromStore();
   if(responseData?.isSubForm || responseData?.isAdvanceListview){
    if(responseData?.stepIndex){
        delete responseData?.stepIndex
    }
    if(responseData?.stepindex){
        delete responseData?.stepindex
    }
    if(responseData?.subStepIndex){
        delete responseData?.subStepIndex
    }
    if(responseData?.substepIndex){
        delete responseData?.substepIndex
    }
    if(responseData?.subChildMenuIndex){
        delete responseData?.subChildMenuIndex
    }
    if(responseData?.parentStepIndex){
        delete responseData?.parentStepIndex
    }
   }
//    if(formState.containerControl === "Menu" && showIcon){
//     delete responseData.stepIndex
//    }
   if(responseData && responseData.id === 'wizard') {
        let wizardIndex = findWizardIndex(formState.children[1].children);
        delete formState.children[1].children.splice(wizardIndex,1);
    }
    else if(responseData && responseData.id?.toLowerCase()?.includes('subwizard')) {
        let wizardJson, stepJson;
        let wizardIndex = findWizardIndex(formState.children[1].children);
        wizardJson = formState.children[1].children[wizardIndex];
        if(responseData.parentSubStepIndex?.toString() && responseData.parentSubStepIndex !== '-1') {
            for(let i = 0; i < wizardJson.children.length; i++) {
                if(wizardJson.children[i].StepIndex?.toString() === responseData.parentStepIndex?.toString()) {
                    for(let j = 0; j < wizardJson.children[i].children.length ; j++) {
                        if(wizardJson.children[i].children[j].SubStepIndex?.toString() === responseData.parentSubStepIndex?.toString()) {
                            stepJson = wizardJson.children[i].children[j];
                        }
                    }
                    break;
                }
            }
        } else {
            for(let i = 0; i < wizardJson.children.length; i++) {
                if(wizardJson.children[i].StepIndex?.toString() === responseData.parentStepIndex?.toString()) {
                    stepJson = wizardJson.children[i];
                    break;
                }
            }
        }
        for(let i = 0 ; i < stepJson.children.length; i++) {
            if(stepJson.children[i]?.id?.toLowerCase()?.includes('subwizard')) {
                stepJson.children.splice(i,1);
                break;
            }
        }
    }
    else if(responseData && responseData.parentStepIndex !== undefined) {
        responseData.parentStepIndex = getStepIndex() + "";
        responseData.parentSubStepIndex = getSubStepIndex() + "";
        let wizardJson, stepJson, subWizardJson, subWizardStepJson;
        let wizardIndex = findWizardIndex(formState.children[1].children);
        wizardJson = formState.children[1].children[wizardIndex];
        if(responseData.subChildMenuIndex?.toString() && responseData.subChildMenuIndex !== '-1') {
            for(let i = 0; i < wizardJson.children.length; i++) {
                if(wizardJson.children[i].StepIndex?.toString() === responseData.stepIndex?.toString()) {
                    for(let j = 0; j < wizardJson.children[i].children.length ; j++) {
                        if(wizardJson.children[i].children[j].SubStepIndex?.toString() === responseData.subStepIndex?.toString()) {
                            for(let k = 0; k < wizardJson.children[i].children[j].children.length; k++) {
                                if(wizardJson.children[i].children[j].children[k].subChildMenuIndex?.toString() === responseData.subChildMenuIndex?.toString()) {                                    
                                    stepJson = wizardJson.children[i].children[j].children[k];
                                }
                            }
                        }
                    }
                    break;
                }
            }
        }
        else if(responseData.parentSubStepIndex?.toString() && responseData.parentSubStepIndex !== '-1') {
            for(let i = 0; i < wizardJson.children.length; i++) {
                if(wizardJson.children[i].StepIndex?.toString() === responseData.parentStepIndex?.toString()) {
                    for(let j = 0; j < wizardJson.children[i].children.length ; j++) {
                        if(wizardJson.children[i].children[j].SubStepIndex?.toString() === responseData.parentSubStepIndex?.toString()) {
                            stepJson = wizardJson.children[i].children[j];
                        }
                    }
                    break;
                }
            }
        } else {
            for(let i = 0; i < wizardJson.children.length; i++) {
                if(wizardJson.children[i].StepIndex?.toString() === responseData.parentStepIndex?.toString()) {
                    stepJson = wizardJson.children[i];
                    break;
                }
            }
        }
        for(let i = 0 ; i < stepJson.children.length; i++) {
            if(stepJson.children[i]?.id?.toLowerCase()?.includes('subwizard')) {
                subWizardJson = stepJson.children[i];
                break;
            }
        }
        if(responseData.subChildMenuIndex?.toString() && responseData.subChildMenuIndex !== '-1') {
            for(let i = 0; i < subWizardJson.children.length; i++) {
                if(subWizardJson.children[i].StepIndex?.toString() === responseData.stepIndex?.toString()) {
                    for(let j = 0; j < subWizardJson.children[i].children.length ; j++) {
                        if(subWizardJson.children[i].children[j].SubStepIndex?.toString() === responseData.subStepIndex?.toString()) {
                            for(let k = 0; k < subWizardJson.children[i].children[j].children.length; k++) {
                                if(subWizardJson.children[i].children[j].children[k].subChildMenuIndex?.toString() === responseData.subChildMenuIndex?.toString()) {                                    
                                    subWizardStepJson = subWizardJson.children[i].children[j].children[k];
                                }
                            }
                        }
                    }
                    break;
                }
            }
        }
        else if(responseData.subStepIndex?.toString() && responseData.subStepIndex !== '-1') {
            for(let i = 0; i < subWizardJson.children.length; i++) {
                if(subWizardJson.children[i].StepIndex?.toString() === responseData.stepIndex?.toString()) {
                    for(let j = 0; j < subWizardJson.children[i].children.length ; j++) {
                        if(subWizardJson.children[i].children[j].SubStepIndex?.toString() === responseData.subStepIndex?.toString()) {
                            subWizardStepJson = subWizardJson.children[i].children[j];
                        }
                    }
                    break;
                }
            }
        } else {
            for(let i = 0; i < subWizardJson.children.length; i++) {
                if(subWizardJson.children[i].StepIndex?.toString() === responseData.stepIndex?.toString()) {
                    subWizardStepJson = subWizardJson.children[i];
                    break;
                }
            }
        }
        fixWizardDeletionIndexes(subWizardJson, subWizardStepJson, responseData);
    }
    else if(responseData && responseData.stepIndex !== undefined) {
        let wizardJson, stepJson;
        responseData.stepIndex = getStepIndex() + "";
        responseData.subStepIndex = getSubStepIndex() + "";
        let wizardIndex = findWizardIndex(formState.children[1].children);
        wizardJson = formState.children[1].children[wizardIndex];
        if(responseData.subChildMenuIndex?.toString() && responseData.subChildMenuIndex !== '-1') {
            for(let i = 0; i < wizardJson.children.length; i++) {
                if(wizardJson.children[i].MainMenuIndex?.toString() === responseData.stepIndex?.toString()) {
                    for(let j = 0; j < wizardJson.children[i].children.length ; j++) {
                        if(wizardJson.children[i].children[j].SubMenuIndex?.toString() === responseData.subStepIndex?.toString()) {
                            for(let k = 0; k < wizardJson.children[i].children[j].children.length; k++) {
                                if(wizardJson.children[i].children[j].children[k].subChildMenuIndex?.toString() === responseData.subChildMenuIndex?.toString()) {                                    
                                    stepJson = wizardJson.children[i].children[j].children[k];
                                }
                            }
                        }
                    }
                    break;
                }
            }
        }
        else if(responseData.subStepIndex?.toString() && responseData.subStepIndex !== '-1') {
            for(let i = 0; i < wizardJson.children.length; i++) {
                if(wizardJson.children[i].StepIndex?.toString() === responseData.stepIndex?.toString() || wizardJson.children[i].MainMenuIndex?.toString() === responseData.stepIndex?.toString()) {
                    for(let j = 0; j < wizardJson.children[i].children.length ; j++) {                        
                        if(wizardJson.children[i].children[j].SubStepIndex?.toString() === responseData.subStepIndex?.toString() || wizardJson.children[i].children[j].SubMenuIndex?.toString() === responseData.subStepIndex?.toString()) {
                            stepJson = wizardJson.children[i].children[j];
                        }
                    }
                    break;
                }
            }
        } else {
            for(let i = 0; i < wizardJson.children.length; i++) {
                if(wizardJson.children[i].StepIndex?.toString() === responseData.stepIndex?.toString() || wizardJson.children[i].MainMenuIndex?.toString() === responseData.stepIndex?.toString()) {
                    stepJson = wizardJson.children[i];
                    break;
                }
            }
        }
        fixWizardDeletionIndexes(wizardJson, stepJson, responseData);
    }
    else if (responseData && responseData.sheetIndex !== undefined) {
        let frameJson,tabJSON,sheetJson;
        for(let i = 0; i < formState.children[1].children.length; i++) {
            if(formState?.children[1]?.children[i]?.frameIndex?.toString() === responseData?.frameIndex?.toString()) {
                frameJson = formState.children[1].children[i];
                break;
            }
        }
        let flag = false;
        if(frameJson.isParentOfTab) {
            tabJSON = frameJson.children[0];
        } else  {
            for(let i = 0; i < frameJson.children[0].children.length; i++){
                for(let j = 0; j < frameJson.children[0].children[i].children.length; j++) {
                    if(frameJson.children[0].children[i].children[j].elementIndex?.toString() === responseData.elementIndex?.toString()) {
                        tabJSON = frameJson.children[0].children[i].children[j];
                        flag = true;
                        break;
                    }
                }
                if(flag)
                    break;
            }
        }
        for(let i = 0; i < tabJSON.children.length; i++) {
            if(tabJSON.children[i].sheetIndex?.toString() === responseData.sheetIndex?.toString()) {
                sheetJson = tabJSON.children[i];
                break;
            }
        }
        if(responseData.elem_type === 'column') {
            if(responseData.sheetElementIndex) {
                let flag = false;
                for(let i = 0; i < sheetJson.children.length; i++) {
                    if(sheetJson.children[i].elem_type === 'row') {
                        for(let j = 0; j < sheetJson.children[i].children.length; j++) {
                            if(sheetJson.children[i].children[j].elem_type === 'column') {
                                for(let k = 0; k < sheetJson.children[i].children[j].children.length; k++) {
                                    if(sheetJson.children[i].children[j].children[k].elem_type === 'frame' && sheetJson.children[i].children[j].children[k].sheetElementIndex?.toString() === responseData.sheetElementIndex?.toString()) {
                                        deleteColumnFromJson(sheetJson.children[i].children[j].children[k],responseData.id);                                        
                                        flag = true;
                                        break;
                                    }
                                    if(flag) break;
                                }
                                if(flag)
                                    break;
                            }   
                        }
                    }
                    if(sheetJson.children[i].elem_type === "column") {
                        for(let j = 0; j < sheetJson.children[i].children.length; j++) {
                            if(sheetJson.children[i].children[j].elem_type === 'frame' && sheetJson.children[i].children[j].sheetElementIndex?.toString() === responseData.sheetElementIndex?.toString()) {
                                deleteColumnFromJson(sheetJson.children[i].children[j],responseData.id);                                        
                                flag = true;
                                break;
                            }
                            if(flag) break;
                        }
                    }
                    if(sheetJson.children[i].elem_type === "frame" && sheetJson.children[i].sheetElementIndex?.toString() === responseData.sheetElementIndex?.toString()){
                        deleteColumnFromJson(sheetJson.children[i],responseData.id);
                    }
                    if(flag) break;
                }
            } else {
                let flag = false;
                for(let i = 0; i < sheetJson.children.length; i++) {
                    if(sheetJson.children[i].elem_type === 'row') {
                        for(let j = 0; j < sheetJson.children[i].children.length; j++) {
                            if(sheetJson.children[i].children[j].elem_type === 'column' && sheetJson.children[i].children[j].id === responseData.id) {
                                sheetJson.children[i].children.splice(j--,1);
                                flag = true;
                                break;
                            }   
                        }
                    }
                    if(flag) break;
                    if(sheetJson.children[i].elem_type === "column" && sheetJson.children[i].id === responseData.id) {
                        sheetJson.children[i].children.splice(i--,1);
                        break;
                    }
                }
            }
        }
        else if(responseData.sheetElementIndex)
        for(let i = 0; i < sheetJson.children.length; i++) {
            if(sheetJson.children[i].elem_type === 'row') {
                for(let j = 0; j < sheetJson.children[i].children.length; j++) {
                    if(sheetJson.children[i].children[j].elem_type === 'column') {
                        deleteFromSheetColumn(sheetJson.children[i].children[j],responseData);
                    }  
                }
            }
            if(sheetJson.children[i].elem_type === "column") {
                deleteFromSheetColumn(sheetJson.children[i],responseData);
            }
            if(sheetJson.children[i].elem_type === "frame" && responseData.sheetFrameElementIndex && responseData.sheetElementIndex?.toString() === sheetJson.children[i].sheetElementIndex?.toString()) {
                deleteControlAndUpdateIndex(sheetJson.children[i],"sheetFrameElementIndex",responseData.sheetFrameElementIndex);
            }
            if((sheetJson.children[i]?.sheetElementIndex?.toString() === responseData.sheetElementIndex?.toString()) && !responseData.sheetFrameElementIndex) {
                sheetJson.children.splice(i--,1);
            }
            else if((parseInt(sheetJson.children[i]?.sheetElementIndex) > parseInt(responseData.sheetElementIndex)) && !responseData.sheetFrameElementIndex) {
                sheetJson.children[i].sheetElementIndex = (parseInt(sheetJson.children[i].sheetElementIndex) -1) + "";
                if(sheetJson.children[i].elem_type === 'frame') {
                    updateIndexInFrame(sheetJson.children[i],sheetJson.children[i].sheetElementIndex,"sheetElementIndex");
                }
            }
        }
        else if(responseData.sheetIndex) {
            for(let i = 0 ; i < sheetJson.children.length; i++) {
                if(sheetJson.children[i].sheetIndex?.toString() === responseData.sheetIndex?.toString()) {
                    sheetJson.children.splice(i--,1);
                }
                else if(parseInt(sheetJson.children[i].sheetIndex) > parseInt(responseData.sheetIndex)) {
                    sheetJson.children.sheetIndex = (parseInt(sheetJson.children.sheetIndex) - 1) + "";
                }
            }
        }
    }
    else if(responseData && responseData.elem_type === "column"){
        let frameJson;
        let firstIndex = responseData.isAdvanceListview ? 0 : 1;
        for(let i = 0 ; i < formState.children[firstIndex].children.length; i++) {
            if(formState.children[firstIndex]?.children[i]?.frameIndex?.toString() === responseData?.frameIndex?.toString()) {
                frameJson = formState.children[firstIndex].children[i];
                break;
            }
        }
        deleteColumnFromJson(frameJson, responseData.id);
    }
    else if (responseData && responseData.frameIndex !== undefined) {
        if((responseData.elementIndex || responseData?.elementIndex === 0) && !responseData.isParentTab) {
            let frameJson;
            let firstIndex = responseData.isAdvanceListview ? 0 : 1;
            for(let i = 0 ; i < formState.children[firstIndex].children.length; i++) {
                if(formState.children[firstIndex]?.children[i]?.frameIndex?.toString() === responseData?.frameIndex?.toString()) {
                    frameJson = formState.children[firstIndex].children[i];
                    break;
                }
            }
            if(responseData?.subFrameElementIndex || responseData?.subFrameElementIndex === 0){
                let updateFrameJson;
                for(let i = 0; i < frameJson.children[0].children.length; i++) {
                    for(let j = 0; j < frameJson.children[0].children[i].children.length; j++) {
                        if(frameJson.children[0].children[i].children[j].elementIndex?.toString() === responseData.elementIndex?.toString()) {
                            updateFrameJson = frameJson.children[0].children[i].children[j];
                            break;
                        }
                    }
                }
                deleteControlAndUpdateIndex(updateFrameJson,"subFrameElementIndex",responseData.subFrameElementIndex);
            }
            else{
                deleteControlAndUpdateIndex(frameJson,"elementIndex",responseData.elementIndex);
            }
        } else {
            let firstIndex = responseData.isAdvanceListview ? 0 : 1;
            for(let i = 0 ; i < formState.children[firstIndex].children.length; i++) {
                if(formState.children[firstIndex]?.children[i]?.frameIndex?.toString() === responseData?.frameIndex?.toString()) {
                    formState.children[firstIndex].children.splice(i--,1);
                    // if(i !== 0){
                    //     i--
                    // }
                    // else{
                    //     i = 0
                    // }
                }
                // else if(parseInt(formState.children[firstIndex]?.children[i]?.frameIndex) > parseInt(responseData?.frameIndex) && formState.children[firstIndex]?.children[i]?.children?.[0]?.elem_type === "tab"){
                //     // formState.children[1].children[i].frameIndex = (parseInt(formState.children[1]?.children[i]?.frameIndex) - 1) + "";
                //     updateFrameIndexesInTab(formState.children[firstIndex]?.children[i])
                // }
                else if(parseInt(formState.children[firstIndex]?.children[i]?.frameIndex) > parseInt(responseData?.frameIndex)) {
                    formState.children[firstIndex].children[i].frameIndex = (parseInt(formState.children[firstIndex]?.children[i]?.frameIndex) - 1) + "";
                    if(formState.children[firstIndex].children[i].elem_type === 'frame') {
                        updateIndexInFrame(formState.children[firstIndex].children[i],formState.children[firstIndex].children[i].frameIndex,"frameIndex");
                    }
                }
            }
        }
    }
}

// export function removeAndUpdateIndex(formState, elemId, elemType, indexToBeDecreasedBy, responseData) {
//     var indexToBeDecreasedKey;
//     var indexToBeMatchedKey;

//     if (responseData && responseData.sheetFrameElementIndex !== undefined) {
//         indexToBeDecreasedKey = 'sheetFrameElementIndex';
//         indexToBeMatchedKey = 'sheetElementIndex';
//     }
//     else if (responseData && responseData.sheetId !== undefined) {
//         indexToBeDecreasedKey = 'sheetElementIndex';
//         indexToBeMatchedKey = 'sheetIndex';
//     }
//     else if (responseData && responseData.elementIndex !== undefined) {
//         indexToBeDecreasedKey = 'elementIndex';
//         indexToBeMatchedKey = 'frameIndex';
//     } else if (responseData && responseData.frameIndex !== undefined) {
//         indexToBeDecreasedKey = "frameIndex";
//         indexToBeMatchedKey = "RootControl"; //for RootControl
//     }
//     var indexInfo = {};
//     recursiveJsonReader(formState, elemId, elemType, indexInfo, indexToBeDecreasedKey, indexToBeMatchedKey);

//     recursiveJsonReader2(formState, elemId, elemType, indexInfo, indexToBeDecreasedKey, indexToBeMatchedKey);
//     flag22 = 0

//     return formState;

// }

// function recursiveJsonReader2(jsonData, elemId, elemType, obj, indexToBeDecreasedKey, indexToBeMatchedKey) {

//     try {
//         if (Array.isArray(jsonData)) {
//             const newJsonData = [...jsonData]
//             newJsonData.map((item, index) => {
//                 if (obj?.updateIndexes === true) {
//                     if ((item[indexToBeMatchedKey] !== undefined) && (parseInt(item[indexToBeMatchedKey]) === parseInt(obj[indexToBeMatchedKey]))) {
//                         let int_indexToBeDecreasedKey = parseInt(item[indexToBeDecreasedKey]);
//                         if (int_indexToBeDecreasedKey > parseInt(obj[indexToBeDecreasedKey]) && item["visited1"] === undefined) {
//                             item[indexToBeDecreasedKey] = (parseInt(item[indexToBeDecreasedKey]) - 1) + '';
//                         }
//                         if(item["visited1"] === true){
//                             delete item["visited1"]
//                         }
//                     } else if (indexToBeMatchedKey === "RootControl" && (item ?.elem_type === elemType)) {
//                         let int_indexToBeDecreasedKey = parseInt(item[indexToBeDecreasedKey]);
//                         if (int_indexToBeDecreasedKey > parseInt(obj[indexToBeDecreasedKey]) && item["visited1"] === undefined) {
//                             item[indexToBeDecreasedKey] = parseInt(item[indexToBeDecreasedKey]) - 1 + "";
//                         }
//                         if(item["visited1"] === true){
//                             delete item["visited1"]
//                         }
//                     } else if (item ?.elem_type === 'row' || item ?.elem_type === 'column') {
//                         let int_indexToBeDecreasedKey = parseInt(item[indexToBeDecreasedKey]);
//                         if (int_indexToBeDecreasedKey > parseInt(obj[indexToBeDecreasedKey]) && item["visited1"] === undefined) {
//                             item[indexToBeDecreasedKey] = parseInt(item[indexToBeDecreasedKey]) - 1 + "";
//                         }
//                         if(item["visited1"] === true){
//                             delete item["visited1"]
//                         }
//                     }
//                     else if ((
//                         item ?.elem_type === 'textbox' ||
//                         item ?.elem_type === 'datepick' ||
//                         item ?.elem_type === 'combo' ||
//                         item ?.elem_type === 'checkbox' ||
//                         item ?.elem_type === 'radio' ||
//                         item ?.elem_type === 'button' ||
//                         item ?.elem_type === 'textarea' ||
//                         item ?.elem_type === 'multiSelect' ||
//                         item ?.elem_type === 'label' ||
//                         item ?.elem_type === 'iframe' ||
//                         item ?.elem_type === 'paragraph' ||
//                         item ?.elem_type === 'image' ||
//                         item ?.elem_type === 'richtexteditor' ||
//                         item ?.elem_type === 'toggle' ||
//                         item ?.elem_type === 'imagecarousel' ||
//                         item ?.elem_type === 'link' ||
//                         item ?.elem_type === 'slider' ||
//                         item ?.elem_type === 'doclist' ||
//                         item ?.elem_type === 'email' ||
//                         item ?.elem_type === 'password' ||
//                         item ?.elem_type === 'percentage' ||
//                         item ?.elem_type === 'phonenumber' ||
//                         item ?.elem_type === 'picklist' ||
//                         item ?.elem_type === 'listbox' ||
//                         item ?.elem_type === 'report' ||
//                         item ?.elem_type === 'CustomControl' ||
//                         item ?.elem_type === 'captcha' ||
//                         item ?.elem_type === 'listview' ||
//                         item ?.elem_type === 'table' ||
//                         item ?.elem_type === 'advancelistview' 
//                     ) && (parseInt(item[indexToBeMatchedKey]) === parseInt(obj[indexToBeMatchedKey]))) {     
//                         let int_indexToBeDecreasedKey = parseInt(item[indexToBeDecreasedKey]);
//                         if (int_indexToBeDecreasedKey > parseInt(obj[indexToBeDecreasedKey]) && item["visited1"] === undefined) {
//                             item[indexToBeDecreasedKey] = parseInt(item[indexToBeDecreasedKey]) - 1 + "";
//                         }
//                         if(item["visited1"] === true){
//                             delete item["visited1"]
//                         }
//                     }
//                     else if ((
//                         item ?.elem_type === 'textbox' ||
//                         item ?.elem_type === 'datepick' ||
//                         item ?.elem_type === 'combo' ||
//                         item ?.elem_type === 'checkbox' ||
//                         item ?.elem_type === 'radio' ||
//                         item ?.elem_type === 'button' ||
//                         item ?.elem_type === 'textarea' ||
//                         item ?.elem_type === 'multiSelect' ||
//                         item ?.elem_type === 'tab' ||
//                         item ?.elem_type === 'label' ||
//                         item ?.elem_type === 'iframe' ||
//                         item ?.elem_type === 'paragraph' ||
//                         item ?.elem_type === 'image' ||
//                         item ?.elem_type === 'richtexteditor' ||
//                         item ?.elem_type === 'wizard_h' ||
//                         item ?.elem_type === 'wizard_v' ||
//                         item ?.elem_type === 'sidenavigation' ||
//                         item ?.elem_type === 'sheet' ||
//                         item ?.elem_type === 'toggle' ||
//                         item ?.elem_type === 'imagecarousel' ||
//                         item ?.elem_type === 'link' ||
//                         item ?.elem_type === 'slider' ||
//                         item ?.elem_type === 'doclist' ||
//                         item ?.elem_type === 'email' ||
//                         item ?.elem_type === 'password' ||
//                         item ?.elem_type === 'percentage' ||
//                         item ?.elem_type === 'phonenumber' ||
//                         item ?.elem_type === 'picklist' ||
//                         item ?.elem_type === 'listbox' ||
//                         item ?.elem_type === 'report' ||
//                         item ?.elem_type === 'CustomControl' ||
//                         item ?.elem_type === 'captcha' ||
//                         item ?.elem_type === 'Menu' || 
//                         item ?.elem_type === 'listview' ||
//                         item ?.elem_type === 'table' ||
//                         item ?.elem_type === 'advancelistview' 
//                     ) && indexToBeMatchedKey === "RootControl") {     
//                         let int_indexToBeDecreasedKey = parseInt(item[indexToBeDecreasedKey]);
//                         if (int_indexToBeDecreasedKey > parseInt(obj[indexToBeDecreasedKey]) && item["visited1"] === undefined) {
//                             item[indexToBeDecreasedKey] = parseInt(item[indexToBeDecreasedKey]) - 1 + "";
//                         }
//                         if(item["visited1"] === true){
//                             delete item["visited1"]
//                         }
//                     }
                    
//                 }
//                 if (item && Object.keys(item).includes("children")) {
//                     obj = recursiveJsonReader2(item, elemId, elemType, obj, indexToBeDecreasedKey, indexToBeMatchedKey);
//                 }

//                 if (item && item["tileContents"]) {                 
//                     if(item?.visited === true){
//                         delete item.visited
//                     }
//                     else{
//                     obj = recursiveJsonReader2(item["tileContents"], elemId, elemType, obj, indexToBeDecreasedKey, indexToBeMatchedKey);
//                     }
//                 }

//             })
//         } else {

//             if (jsonData && jsonData["id"] !== elemId) {
//                 obj = recursiveJsonReader2(jsonData["children"], elemId, elemType, obj, indexToBeDecreasedKey, indexToBeMatchedKey);

//             }
//             else { 
//                 if((obj.elementIndex === undefined || obj.elementIndex === null) && (obj?.sheetElementIndex === undefined || obj?.sheetElementIndex === null)){
//                 obj[indexToBeDecreasedKey] = parseInt(jsonData[indexToBeDecreasedKey]);
//                 obj[indexToBeMatchedKey] = jsonData[indexToBeMatchedKey]
//                 }
//             }
//         }
//         return (obj);
//     } catch (e) {

//     }
// }


function updateIndex(jsonData, indexInfo, indexToBeDecreasedKey, indexToBeDecreasedBy, indexToBeMatchedKey, elemType = "") {
    try {
        if (Array.isArray(jsonData)) {
            jsonData.forEach((item, index) => {

                if (item && item[indexToBeDecreasedKey] && item[indexToBeMatchedKey] === indexInfo[indexToBeMatchedKey] &&
                    parseInt(indexInfo[indexToBeDecreasedKey]) < item[indexToBeDecreasedKey]) {

                    item[indexToBeDecreasedKey] = (parseInt(item[indexToBeDecreasedKey]) - indexToBeDecreasedBy) + '';
                }

                if (item && Object.keys(item).includes("children")) {
                    updateIndex(item["children"], indexInfo, indexToBeDecreasedKey, indexToBeDecreasedBy, indexToBeMatchedKey);

                }
                if (item && item["tileContents"] && elemType === "tile") {
                    updateIndex(item["tileContents"], indexInfo, indexToBeDecreasedKey, indexToBeDecreasedBy, indexToBeMatchedKey);
                }
            })
        } else {
            if (jsonData && jsonData[indexToBeDecreasedKey] && jsonData[indexToBeMatchedKey] === indexInfo[indexToBeMatchedKey] &&
                parseInt(indexInfo[indexToBeDecreasedKey]) < jsonData[indexToBeDecreasedKey]) {
                jsonData[indexToBeDecreasedKey] = (parseInt(jsonData[indexToBeDecreasedKey]) - indexToBeDecreasedBy) + '';
            }
            if (jsonData && jsonData["children"]) {
                updateIndex(jsonData["children"], indexInfo, indexToBeDecreasedKey, indexToBeDecreasedBy, indexToBeMatchedKey);

            }

        }

    } catch (e) {

    }

}

export function updateIndexByIncreasing(jsonData, indexInfo, indexToBeDecreasedKey, indexToBeDecreasedBy, indexToBeMatchedKey) {

    try {
        if (Array.isArray(jsonData)) {
            jsonData.forEach((item, index) => {
                if (item && item[indexToBeDecreasedKey] && item[indexToBeMatchedKey] === indexInfo[indexToBeMatchedKey] &&
                    parseInt(indexInfo[indexToBeDecreasedKey]) >= item[indexToBeDecreasedKey]) {

                    item[indexToBeDecreasedKey] = (parseInt(item[indexToBeDecreasedKey]) + indexToBeDecreasedBy) + '';
                }

                if (item && Object.keys(item).includes("children")) {
                    updateIndexByIncreasing(item["children"], indexInfo, indexToBeDecreasedKey, indexToBeDecreasedBy, indexToBeMatchedKey);

                }
            })
        } else { 
            if (jsonData && jsonData[indexToBeDecreasedKey] && jsonData[indexToBeMatchedKey] === indexInfo[indexToBeMatchedKey] &&
                parseInt(indexInfo[indexToBeDecreasedKey]) >= jsonData[indexToBeDecreasedKey]) {

                jsonData[indexToBeDecreasedKey] = (parseInt(jsonData[indexToBeDecreasedKey]) + indexToBeDecreasedBy) + '';
            }
            if (jsonData && jsonData["children"]) {
                updateIndexByIncreasing(jsonData["children"], indexInfo, indexToBeDecreasedKey, indexToBeDecreasedBy, indexToBeMatchedKey);

            }
        }

    } catch (e) {

    }
    return jsonData;

}

export async function updatePositionInform(JsonOfReorderElem,targetParent,newPos,isParentTab,isParentMenu,isParentWizard,openCanvasForSubform,tabSectionSwap) {
    var jsonToSend = {};
    var remainingURL = '';

    if(isParentTab){
         if(JsonOfReorderElem?.parentRow.includes("row") && targetParent?.elem_type === "sheet") {
            jsonToSend = {
                newPosition: newPos,
                oldPosition: JsonOfReorderElem.json?.children[0]?.sheetElementIndex,
                frameIndex : JsonOfReorderElem.json?.children[0]?.frameIndex,
                elementIndex: JsonOfReorderElem.json?.children[0]?.elementIndex,
                sheetId: targetParent?.sheetIndex,
                ...(getStepIndex() && getStepIndex() !== "-1" && {
                    stepIndex: getStepIndex(),
                    subStepIndex: getSubStepIndex(),
                }),
                isSubForm: openCanvasForSubform === "subform" ? true :false,
                isAdvanceListview:openCanvasForSubform === "advanceListviewFromScratch" ? true :false,
              };
              remainingURL = '/idesign/updateTabElementPosition';
              window.callIdentity = "updateTabElementPosition"
    
        }  else if(JsonOfReorderElem?.parentRow.includes("row") && targetParent?.elem_type !== "sheet"){
            jsonToSend = {
                newPosition: newPos,
                oldPosition: JsonOfReorderElem.json?.children[0]?.sheetFrameElementIndex,
                frameIndex : JsonOfReorderElem.json?.children[0]?.frameIndex,
                elementIndex: JsonOfReorderElem.json?.children[0]?.elementIndex,
                sheetId: targetParent?.sheetIndex,
                sheetElementIndex:  JsonOfReorderElem.json?.children[0]?.sheetElementIndex,
                ...(getStepIndex() && getStepIndex() !== "-1" && {
                    stepIndex: getStepIndex(),
                    subStepIndex: getSubStepIndex(),
                }),
                isSubForm: openCanvasForSubform === "subform" ? true :false,
                isAdvanceListview:openCanvasForSubform === "advanceListviewFromScratch" ? true :false,
              };
              remainingURL = '/idesign/updateTabFrameElementPosition';
              window.callIdentity = "updateTabFrameElementPosition"
        } else if(JsonOfReorderElem?.parentRow.includes("sheet")) {
            jsonToSend = {
                newPosition: newPos,
                oldPosition: JsonOfReorderElem.json?.sheetElementIndex,
                frameIndex : JsonOfReorderElem.json?.frameIndex,
                sheetId: targetParent?.sheetIndex,
                elementIndex: targetParent?.elementIndex,
                ...(getStepIndex() && getStepIndex() !== "-1" && {
                    stepIndex: getStepIndex(),
                    subStepIndex: getSubStepIndex(),
                }),
                isSubForm: openCanvasForSubform === "subform" ? true :false,
                isAdvanceListview:openCanvasForSubform === "advanceListviewFromScratch" ? true :false,
              };
              remainingURL = '/idesign/updateTabFramePosition';
              window.callIdentity = "updateTabFramePosition"
        } else if(JsonOfReorderElem?.parentRow?.includes("column") && JsonOfReorderElem?.id?.includes("frame") && document.getElementById(`${JsonOfReorderElem?.parentRow}`).closest(`[elem_type="tab"]`)){
            jsonToSend = {
                newPosition: newPos,
                oldPosition: JsonOfReorderElem.json?.sheetElementIndex,
                frameIndex : JsonOfReorderElem.json?.frameIndex,
                sheetId: targetParent?.sheetIndex,
                elementIndex: targetParent?.elementIndex,
                ...(getStepIndex() && getStepIndex() !== "-1" && {
                    stepIndex: getStepIndex(),
                    subStepIndex: getSubStepIndex(),
                }),
                isSubForm: openCanvasForSubform === "subform" ? true :false,
                isAdvanceListview:openCanvasForSubform === "advanceListviewFromScratch" ? true :false,
              };
              remainingURL = '/idesign/updateTabFramePosition';
              window.callIdentity = "updateTabFramePosition"
        }else if(JsonOfReorderElem?.id.includes("frame")) {
            jsonToSend = {
                opType: 3,
                frameIndex: JsonOfReorderElem?.json?.frameIndex,
                elementIndex: JsonOfReorderElem?.json?.elementIndex,
                sheetId: JsonOfReorderElem?.json?.sheetId,
                newPosition: newPos,
                oldPosition: JsonOfReorderElem?.json?.sheetElementIndex,
                ...(getStepIndex() && getStepIndex() !== "-1" && {
                    stepIndex: getStepIndex(),
                    subStepIndex: getSubStepIndex(),
                }),
                isSubForm: JsonOfReorderElem?.json?.isSubForm,
                isAdvanceListview: JsonOfReorderElem?.json?.isAdvanceListview,
            }
            remainingURL = '/idesign/updatePostitionInForm'
        }
    } else if(isParentWizard || isParentMenu){
       if(JsonOfReorderElem?.parentRow.includes("Step") || JsonOfReorderElem?.parentRow.includes("MainMenu")|| JsonOfReorderElem?.parentRow.includes("SubMenu")|| JsonOfReorderElem?.parentRow.includes("SubChildMenu")) {
        if(isParentWizard) {
            jsonToSend = {
                newPosition: newPos,
                oldPosition: JsonOfReorderElem.json?.frameIndex,
                frameIndex : JsonOfReorderElem.json?.frameIndex,
                sheetId: targetParent?.sheetIndex,
                subChildMenuIndex:JsonOfReorderElem?.subChildMenuIndex,
                stepIndex: getStepIndex(),
                subStepIndex: getSubStepIndex(),
                isSubForm: openCanvasForSubform === "subform" ? true :false,
                isAdvanceListview:openCanvasForSubform === "advanceListviewFromScratch" ? true :false,
              };
        }
        else
            jsonToSend = {
                newPosition: newPos,
                oldPosition: JsonOfReorderElem.json?.frameIndex,
                frameIndex : JsonOfReorderElem.json?.frameIndex,
                sheetId: targetParent?.sheetIndex,
                stepIndex:JsonOfReorderElem?.stepIndex,
                subChildMenuIndex:JsonOfReorderElem?.subChildMenuIndex,
                subStepIndex:JsonOfReorderElem?.substepIndex,
                isSubForm: openCanvasForSubform === "subform" ? true :false,
                isAdvanceListview:openCanvasForSubform === "advanceListviewFromScratch" ? true :false,
          };
          remainingURL = '/idesign/updatePositionForMenuFrame';
          window.callIdentity = "updatePositionForMenuFrame"
       } else {
        if(isParentWizard) {
            jsonToSend = {
                newPosition: newPos,
                oldPosition: JsonOfReorderElem.json?.children[0]?.subFrameElementIndex || JsonOfReorderElem.json?.children[0]?.elementIndex,
                frameIndex : JsonOfReorderElem.json?.children[0]?.frameIndex,
                stepIndex:getStepIndex(),
                subChildMenuIndex:JsonOfReorderElem?.subChildMenuIndex,
                subStepIndex:getSubStepIndex(),
                isSubForm: openCanvasForSubform === "subform" ? true :false,
                isAdvanceListview:openCanvasForSubform === "advanceListviewFromScratch" ? true :false,
            };
        }
        else
            jsonToSend = {
                newPosition: newPos,
                oldPosition: JsonOfReorderElem.json?.children[0]?.subFrameElementIndex || JsonOfReorderElem.json?.children[0]?.elementIndex,
                frameIndex : JsonOfReorderElem.json?.children[0]?.frameIndex,
                stepIndex:JsonOfReorderElem?.stepIndex,
                subChildMenuIndex:JsonOfReorderElem?.subChildMenuIndex,
                subStepIndex:JsonOfReorderElem?.substepIndex,
                isSubForm: openCanvasForSubform === "subform" ? true :false,
                isAdvanceListview:openCanvasForSubform === "advanceListviewFromScratch" ? true :false,
            };
          remainingURL = '/idesign/updatePositionForMenuFrameElement';
          window.callIdentity = "updatePositionForMenuFrameElement"
       }
    } else {
    if(JsonOfReorderElem?.parentRow === "RootControl" || tabSectionSwap || ( JsonOfReorderElem?.json?.elem_type === 'tab' && document.getElementById(JsonOfReorderElem?.id).closest(`[parentframeid=${JsonOfReorderElem?.parentRow}]`).parentNode.getAttribute('id') === 'RootControl')) {
        jsonToSend = {
            newPosition: newPos,
            oldPosition: JsonOfReorderElem.json?.frameIndex,
            frameIndex : JsonOfReorderElem.json?.frameIndex,
            isAdvanceListview:openCanvasForSubform === "advanceListviewFromScratch" ? true :false,
            isSubForm: openCanvasForSubform === "subform" ? true :false,
            ...(getStepIndex() && getStepIndex() !== "-1" && {
                stepIndex: getStepIndex(),
                subStepIndex: getSubStepIndex(),
            })
          };
          remainingURL = '/idesign/updateframepostion';
          window.callIdentity = "updateframepostion"
    } else if((JsonOfReorderElem?.parentRow.includes("row") || JsonOfReorderElem?.parentRow.includes("column")) && targetParent?.elem_type !== "sheet" ){
        jsonToSend = {
            newPosition: newPos,
            oldPosition: (JsonOfReorderElem?.absoluteParent?.includes("frame") && JsonOfReorderElem?.json?.elementIndex) || JsonOfReorderElem.json?.children[0]?.subFrameElementIndex || JsonOfReorderElem.json?.children[0]?.elementIndex || JsonOfReorderElem.json?.children[0]?.tileContents[0]?.elementIndex,
            frameIndex : JsonOfReorderElem.json?.frameIndex,
            ...(getStepIndex() && getStepIndex() !== "-1" && {
                stepIndex: getStepIndex(),
                subStepIndex: getSubStepIndex(),
            }),
            isSubForm: openCanvasForSubform === "subform" ? true :false,
            isAdvanceListview:openCanvasForSubform === "advanceListviewFromScratch" ? true :false,
          };
          remainingURL = '/idesign/updatePosition';
          window.callIdentity = "updatePosition"
    } 
}
    let formId = getFormId()
    jsonToSend.formId = formId?.toString();
    if(remainingURL !== ""){
        return await axios.post(remainingURL, jsonToSend, { withCredentials: true });
    }
}

export function findAndDeleteControlSet(formState, elemId){
    formState?.controlSet?.map((constrolSet) => {
        delete constrolSet[elemId]
    })
}

export function recursionMapping(contentData, tempData, dataClassAdvacnceListview) {
    let stack = [...contentData]; // Initialize stack with root nodes

    while (stack.length > 0) {
        let content = stack.pop();
        
        if (content["VariableName"] === dataClassAdvacnceListview || content["treeName"] === dataClassAdvacnceListview) {
        tempData.push(content);
        }
        
        if (content["children"] && content["children"].length > 0) {
        stack.push(...content["children"]);
        }
    }
}

export function checkIsAdvancedListviewChild(alvData, targetTreeName) {
  if (!alvData) return false;

  if (alvData.treeName === targetTreeName) {
    return true;
  }

  if (Array.isArray(alvData.children)) {
    return alvData.children.some(child => checkIsAdvancedListviewChild(child, targetTreeName));
  }

  return false;
}

export function findFrameColumnLayout(frameJson, deviceType = 'web'){
    let frameColumnLayout = 0;
    if(frameJson?.elem_type === "frame"){
    if(deviceType === "mobile"){
        frameColumnLayout = frameJson.xs ? frameJson.xs : frameJson?.ColumnLayout;
    } else if(deviceType === "tablet"){
        frameColumnLayout = frameJson.sm ? frameJson.sm : frameJson?.ColumnLayout;
    } else {
        frameColumnLayout = frameJson.w ? frameJson.w : frameJson.ColumnLayout;
    }
    return frameColumnLayout;
    }
}